'use strict';

var cov_1ytb5bt5lt = function () {
  var path = '/Users/mxu/code/uport-connect/src/Connect.js',
      hash = 'ee0bda2b737d337c54339c79ebfa32b64d0ff5a8',
      Function = function () {}.constructor,
      global = new Function('return this')(),
      gcv = '__coverage__',
      coverageData = {
    path: '/Users/mxu/code/uport-connect/src/Connect.js',
    statementMap: {
      '0': {
        start: {
          line: 44,
          column: 4
        },
        end: {
          line: 44,
          column: 49
        }
      },
      '1': {
        start: {
          line: 45,
          column: 4
        },
        end: {
          line: 45,
          column: 39
        }
      },
      '2': {
        start: {
          line: 46,
          column: 4
        },
        end: {
          line: 46,
          column: 41
        }
      },
      '3': {
        start: {
          line: 47,
          column: 4
        },
        end: {
          line: 47,
          column: 39
        }
      },
      '4': {
        start: {
          line: 48,
          column: 4
        },
        end: {
          line: 48,
          column: 37
        }
      },
      '5': {
        start: {
          line: 49,
          column: 4
        },
        end: {
          line: 49,
          column: 55
        }
      },
      '6': {
        start: {
          line: 50,
          column: 4
        },
        end: {
          line: 50,
          column: 81
        }
      },
      '7': {
        start: {
          line: 51,
          column: 4
        },
        end: {
          line: 51,
          column: 78
        }
      },
      '8': {
        start: {
          line: 52,
          column: 4
        },
        end: {
          line: 52,
          column: 70
        }
      },
      '9': {
        start: {
          line: 53,
          column: 4
        },
        end: {
          line: 53,
          column: 67
        }
      },
      '10': {
        start: {
          line: 54,
          column: 4
        },
        end: {
          line: 54,
          column: 51
        }
      },
      '11': {
        start: {
          line: 57,
          column: 4
        },
        end: {
          line: 59,
          column: 5
        }
      },
      '12': {
        start: {
          line: 58,
          column: 6
        },
        end: {
          line: 58,
          column: 73
        }
      },
      '13': {
        start: {
          line: 62,
          column: 4
        },
        end: {
          line: 62,
          column: 54
        }
      },
      '14': {
        start: {
          line: 65,
          column: 4
        },
        end: {
          line: 65,
          column: 20
        }
      },
      '15': {
        start: {
          line: 68,
          column: 4
        },
        end: {
          line: 68,
          column: 39
        }
      },
      '16': {
        start: {
          line: 68,
          column: 23
        },
        end: {
          line: 68,
          column: 39
        }
      },
      '17': {
        start: {
          line: 69,
          column: 4
        },
        end: {
          line: 69,
          column: 70
        }
      },
      '18': {
        start: {
          line: 69,
          column: 27
        },
        end: {
          line: 69,
          column: 70
        }
      },
      '19': {
        start: {
          line: 72,
          column: 4
        },
        end: {
          line: 72,
          column: 24
        }
      },
      '20': {
        start: {
          line: 73,
          column: 4
        },
        end: {
          line: 73,
          column: 64
        }
      },
      '21': {
        start: {
          line: 74,
          column: 4
        },
        end: {
          line: 74,
          column: 28
        }
      },
      '22': {
        start: {
          line: 75,
          column: 4
        },
        end: {
          line: 78,
          column: 6
        }
      },
      '23': {
        start: {
          line: 77,
          column: 27
        },
        end: {
          line: 77,
          column: 123
        }
      },
      '24': {
        start: {
          line: 79,
          column: 4
        },
        end: {
          line: 79,
          column: 76
        }
      },
      '25': {
        start: {
          line: 80,
          column: 4
        },
        end: {
          line: 80,
          column: 125
        }
      },
      '26': {
        start: {
          line: 81,
          column: 4
        },
        end: {
          line: 86,
          column: 6
        }
      },
      '27': {
        start: {
          line: 82,
          column: 6
        },
        end: {
          line: 82,
          column: 24
        }
      },
      '28': {
        start: {
          line: 82,
          column: 15
        },
        end: {
          line: 82,
          column: 24
        }
      },
      '29': {
        start: {
          line: 84,
          column: 6
        },
        end: {
          line: 84,
          column: 30
        }
      },
      '30': {
        start: {
          line: 85,
          column: 6
        },
        end: {
          line: 85,
          column: 27
        }
      },
      '31': {
        start: {
          line: 89,
          column: 4
        },
        end: {
          line: 89,
          column: 110
        }
      },
      '32': {
        start: {
          line: 90,
          column: 4
        },
        end: {
          line: 90,
          column: 115
        }
      },
      '33': {
        start: {
          line: 91,
          column: 4
        },
        end: {
          line: 91,
          column: 89
        }
      },
      '34': {
        start: {
          line: 109,
          column: 24
        },
        end: {
          line: 132,
          column: 6
        }
      },
      '35': {
        start: {
          line: 111,
          column: 26
        },
        end: {
          line: 111,
          column: 46
        }
      },
      '36': {
        start: {
          line: 112,
          column: 8
        },
        end: {
          line: 112,
          column: 87
        }
      },
      '37': {
        start: {
          line: 113,
          column: 8
        },
        end: {
          line: 113,
          column: 74
        }
      },
      '38': {
        start: {
          line: 113,
          column: 54
        },
        end: {
          line: 113,
          column: 73
        }
      },
      '39': {
        start: {
          line: 116,
          column: 8
        },
        end: {
          line: 116,
          column: 28
        }
      },
      '40': {
        start: {
          line: 117,
          column: 26
        },
        end: {
          line: 117,
          column: 41
        }
      },
      '41': {
        start: {
          line: 118,
          column: 8
        },
        end: {
          line: 118,
          column: 46
        }
      },
      '42': {
        start: {
          line: 119,
          column: 8
        },
        end: {
          line: 119,
          column: 66
        }
      },
      '43': {
        start: {
          line: 119,
          column: 54
        },
        end: {
          line: 119,
          column: 65
        }
      },
      '44': {
        start: {
          line: 122,
          column: 26
        },
        end: {
          line: 122,
          column: 51
        }
      },
      '45': {
        start: {
          line: 123,
          column: 8
        },
        end: {
          line: 123,
          column: 60
        }
      },
      '46': {
        start: {
          line: 124,
          column: 8
        },
        end: {
          line: 124,
          column: 66
        }
      },
      '47': {
        start: {
          line: 124,
          column: 54
        },
        end: {
          line: 124,
          column: 65
        }
      },
      '48': {
        start: {
          line: 127,
          column: 26
        },
        end: {
          line: 127,
          column: 51
        }
      },
      '49': {
        start: {
          line: 128,
          column: 8
        },
        end: {
          line: 128,
          column: 49
        }
      },
      '50': {
        start: {
          line: 129,
          column: 8
        },
        end: {
          line: 129,
          column: 66
        }
      },
      '51': {
        start: {
          line: 129,
          column: 54
        },
        end: {
          line: 129,
          column: 65
        }
      },
      '52': {
        start: {
          line: 133,
          column: 4
        },
        end: {
          line: 133,
          column: 58
        }
      },
      '53': {
        start: {
          line: 133,
          column: 22
        },
        end: {
          line: 133,
          column: 58
        }
      },
      '54': {
        start: {
          line: 134,
          column: 4
        },
        end: {
          line: 134,
          column: 22
        }
      },
      '55': {
        start: {
          line: 147,
          column: 26
        },
        end: {
          line: 165,
          column: 5
        }
      },
      '56': {
        start: {
          line: 148,
          column: 6
        },
        end: {
          line: 148,
          column: 68
        }
      },
      '57': {
        start: {
          line: 148,
          column: 21
        },
        end: {
          line: 148,
          column: 68
        }
      },
      '58': {
        start: {
          line: 149,
          column: 6
        },
        end: {
          line: 164,
          column: 7
        }
      },
      '59': {
        start: {
          line: 150,
          column: 20
        },
        end: {
          line: 150,
          column: 31
        }
      },
      '60': {
        start: {
          line: 151,
          column: 24
        },
        end: {
          line: 151,
          column: 38
        }
      },
      '61': {
        start: {
          line: 152,
          column: 8
        },
        end: {
          line: 154,
          column: 9
        }
      },
      '62': {
        start: {
          line: 153,
          column: 10
        },
        end: {
          line: 153,
          column: 58
        }
      },
      '63': {
        start: {
          line: 155,
          column: 8
        },
        end: {
          line: 161,
          column: 10
        }
      },
      '64': {
        start: {
          line: 158,
          column: 10
        },
        end: {
          line: 158,
          column: 73
        }
      },
      '65': {
        start: {
          line: 158,
          column: 32
        },
        end: {
          line: 158,
          column: 73
        }
      },
      '66': {
        start: {
          line: 159,
          column: 10
        },
        end: {
          line: 159,
          column: 34
        }
      },
      '67': {
        start: {
          line: 160,
          column: 10
        },
        end: {
          line: 160,
          column: 57
        }
      },
      '68': {
        start: {
          line: 163,
          column: 8
        },
        end: {
          line: 163,
          column: 56
        }
      },
      '69': {
        start: {
          line: 167,
          column: 4
        },
        end: {
          line: 171,
          column: 5
        }
      },
      '70': {
        start: {
          line: 168,
          column: 29
        },
        end: {
          line: 168,
          column: 48
        }
      },
      '71': {
        start: {
          line: 169,
          column: 6
        },
        end: {
          line: 169,
          column: 32
        }
      },
      '72': {
        start: {
          line: 170,
          column: 6
        },
        end: {
          line: 170,
          column: 42
        }
      },
      '73': {
        start: {
          line: 173,
          column: 4
        },
        end: {
          line: 187,
          column: 5
        }
      },
      '74': {
        start: {
          line: 174,
          column: 6
        },
        end: {
          line: 179,
          column: 8
        }
      },
      '75': {
        start: {
          line: 175,
          column: 8
        },
        end: {
          line: 178,
          column: 9
        }
      },
      '76': {
        start: {
          line: 176,
          column: 21
        },
        end: {
          line: 176,
          column: 34
        }
      },
      '77': {
        start: {
          line: 177,
          column: 21
        },
        end: {
          line: 177,
          column: 34
        }
      },
      '78': {
        start: {
          line: 181,
          column: 6
        },
        end: {
          line: 186,
          column: 8
        }
      },
      '79': {
        start: {
          line: 182,
          column: 8
        },
        end: {
          line: 185,
          column: 10
        }
      },
      '80': {
        start: {
          line: 183,
          column: 10
        },
        end: {
          line: 183,
          column: 37
        }
      },
      '81': {
        start: {
          line: 184,
          column: 10
        },
        end: {
          line: 184,
          column: 50
        }
      },
      '82': {
        start: {
          line: 200,
          column: 4
        },
        end: {
          line: 200,
          column: 85
        }
      },
      '83': {
        start: {
          line: 200,
          column: 35
        },
        end: {
          line: 200,
          column: 85
        }
      },
      '84': {
        start: {
          line: 201,
          column: 4
        },
        end: {
          line: 201,
          column: 86
        }
      },
      '85': {
        start: {
          line: 211,
          column: 4
        },
        end: {
          line: 214,
          column: 6
        }
      },
      '86': {
        start: {
          line: 212,
          column: 6
        },
        end: {
          line: 212,
          column: 24
        }
      },
      '87': {
        start: {
          line: 213,
          column: 6
        },
        end: {
          line: 213,
          column: 59
        }
      },
      '88': {
        start: {
          line: 229,
          column: 4
        },
        end: {
          line: 229,
          column: 51
        }
      },
      '89': {
        start: {
          line: 229,
          column: 13
        },
        end: {
          line: 229,
          column: 51
        }
      },
      '90': {
        start: {
          line: 230,
          column: 4
        },
        end: {
          line: 237,
          column: 5
        }
      },
      '91': {
        start: {
          line: 231,
          column: 6
        },
        end: {
          line: 231,
          column: 49
        }
      },
      '92': {
        start: {
          line: 231,
          column: 32
        },
        end: {
          line: 231,
          column: 49
        }
      },
      '93': {
        start: {
          line: 232,
          column: 6
        },
        end: {
          line: 232,
          column: 66
        }
      },
      '94': {
        start: {
          line: 233,
          column: 11
        },
        end: {
          line: 237,
          column: 5
        }
      },
      '95': {
        start: {
          line: 234,
          column: 6
        },
        end: {
          line: 234,
          column: 83
        }
      },
      '96': {
        start: {
          line: 234,
          column: 54
        },
        end: {
          line: 234,
          column: 82
        }
      },
      '97': {
        start: {
          line: 236,
          column: 6
        },
        end: {
          line: 236,
          column: 87
        }
      },
      '98': {
        start: {
          line: 236,
          column: 58
        },
        end: {
          line: 236,
          column: 86
        }
      },
      '99': {
        start: {
          line: 261,
          column: 25
        },
        end: {
          line: 265,
          column: 5
        }
      },
      '100': {
        start: {
          line: 262,
          column: 6
        },
        end: {
          line: 262,
          column: 31
        }
      },
      '101': {
        start: {
          line: 263,
          column: 6
        },
        end: {
          line: 263,
          column: 30
        }
      },
      '102': {
        start: {
          line: 264,
          column: 6
        },
        end: {
          line: 264,
          column: 54
        }
      },
      '103': {
        start: {
          line: 266,
          column: 4
        },
        end: {
          line: 266,
          column: 56
        }
      },
      '104': {
        start: {
          line: 291,
          column: 4
        },
        end: {
          line: 291,
          column: 52
        }
      },
      '105': {
        start: {
          line: 291,
          column: 19
        },
        end: {
          line: 291,
          column: 52
        }
      },
      '106': {
        start: {
          line: 292,
          column: 4
        },
        end: {
          line: 296,
          column: 5
        }
      },
      '107': {
        start: {
          line: 299,
          column: 4
        },
        end: {
          line: 299,
          column: 61
        }
      },
      '108': {
        start: {
          line: 299,
          column: 13
        },
        end: {
          line: 299,
          column: 61
        }
      },
      '109': {
        start: {
          line: 300,
          column: 4
        },
        end: {
          line: 301,
          column: 48
        }
      },
      '110': {
        start: {
          line: 301,
          column: 19
        },
        end: {
          line: 301,
          column: 47
        }
      },
      '111': {
        start: {
          line: 327,
          column: 4
        },
        end: {
          line: 327,
          column: 37
        }
      },
      '112': {
        start: {
          line: 328,
          column: 4
        },
        end: {
          line: 333,
          column: 5
        }
      },
      '113': {
        start: {
          line: 329,
          column: 6
        },
        end: {
          line: 329,
          column: 96
        }
      },
      '114': {
        start: {
          line: 330,
          column: 6
        },
        end: {
          line: 330,
          column: 24
        }
      },
      '115': {
        start: {
          line: 331,
          column: 11
        },
        end: {
          line: 333,
          column: 5
        }
      },
      '116': {
        start: {
          line: 332,
          column: 6
        },
        end: {
          line: 332,
          column: 79
        }
      },
      '117': {
        start: {
          line: 335,
          column: 4
        },
        end: {
          line: 336,
          column: 48
        }
      },
      '118': {
        start: {
          line: 336,
          column: 19
        },
        end: {
          line: 336,
          column: 47
        }
      },
      '119': {
        start: {
          line: 347,
          column: 17
        },
        end: {
          line: 350,
          column: 5
        }
      },
      '120': {
        start: {
          line: 351,
          column: 4
        },
        end: {
          line: 351,
          column: 46
        }
      },
      '121': {
        start: {
          line: 351,
          column: 22
        },
        end: {
          line: 351,
          column: 46
        }
      },
      '122': {
        start: {
          line: 352,
          column: 4
        },
        end: {
          line: 352,
          column: 111
        }
      },
      '123': {
        start: {
          line: 352,
          column: 82
        },
        end: {
          line: 352,
          column: 110
        }
      },
      '124': {
        start: {
          line: 363,
          column: 17
        },
        end: {
          line: 366,
          column: 5
        }
      },
      '125': {
        start: {
          line: 367,
          column: 4
        },
        end: {
          line: 367,
          column: 46
        }
      },
      '126': {
        start: {
          line: 367,
          column: 22
        },
        end: {
          line: 367,
          column: 46
        }
      },
      '127': {
        start: {
          line: 369,
          column: 4
        },
        end: {
          line: 369,
          column: 100
        }
      },
      '128': {
        start: {
          line: 369,
          column: 71
        },
        end: {
          line: 369,
          column: 99
        }
      },
      '129': {
        start: {
          line: 398,
          column: 4
        },
        end: {
          line: 398,
          column: 53
        }
      },
      '130': {
        start: {
          line: 398,
          column: 20
        },
        end: {
          line: 398,
          column: 53
        }
      },
      '131': {
        start: {
          line: 400,
          column: 4
        },
        end: {
          line: 404,
          column: 14
        }
      },
      '132': {
        start: {
          line: 406,
          column: 4
        },
        end: {
          line: 409,
          column: 5
        }
      },
      '133': {
        start: {
          line: 407,
          column: 6
        },
        end: {
          line: 407,
          column: 40
        }
      },
      '134': {
        start: {
          line: 408,
          column: 6
        },
        end: {
          line: 408,
          column: 41
        }
      },
      '135': {
        start: {
          line: 412,
          column: 4
        },
        end: {
          line: 413,
          column: 48
        }
      },
      '136': {
        start: {
          line: 413,
          column: 19
        },
        end: {
          line: 413,
          column: 47
        }
      },
      '137': {
        start: {
          line: 437,
          column: 4
        },
        end: {
          line: 437,
          column: 59
        }
      },
      '138': {
        start: {
          line: 437,
          column: 26
        },
        end: {
          line: 437,
          column: 59
        }
      },
      '139': {
        start: {
          line: 439,
          column: 15
        },
        end: {
          line: 439,
          column: 35
        }
      },
      '140': {
        start: {
          line: 440,
          column: 4
        },
        end: {
          line: 440,
          column: 66
        }
      },
      '141': {
        start: {
          line: 441,
          column: 4
        },
        end: {
          line: 444,
          column: 6
        }
      },
      '142': {
        start: {
          line: 442,
          column: 18
        },
        end: {
          line: 442,
          column: 104
        }
      },
      '143': {
        start: {
          line: 443,
          column: 6
        },
        end: {
          line: 443,
          column: 34
        }
      },
      '144': {
        start: {
          line: 455,
          column: 4
        },
        end: {
          line: 466,
          column: 5
        }
      },
      '145': {
        start: {
          line: 457,
          column: 8
        },
        end: {
          line: 457,
          column: 51
        }
      },
      '146': {
        start: {
          line: 458,
          column: 8
        },
        end: {
          line: 458,
          column: 13
        }
      },
      '147': {
        start: {
          line: 460,
          column: 8
        },
        end: {
          line: 460,
          column: 41
        }
      },
      '148': {
        start: {
          line: 461,
          column: 8
        },
        end: {
          line: 461,
          column: 13
        }
      },
      '149': {
        start: {
          line: 463,
          column: 8
        },
        end: {
          line: 463,
          column: 13
        }
      },
      '150': {
        start: {
          line: 465,
          column: 8
        },
        end: {
          line: 465,
          column: 61
        }
      },
      '151': {
        start: {
          line: 468,
          column: 21
        },
        end: {
          line: 468,
          column: 32
        }
      },
      '152': {
        start: {
          line: 469,
          column: 4
        },
        end: {
          line: 474,
          column: 5
        }
      },
      '153': {
        start: {
          line: 470,
          column: 6
        },
        end: {
          line: 470,
          column: 48
        }
      },
      '154': {
        start: {
          line: 471,
          column: 11
        },
        end: {
          line: 474,
          column: 5
        }
      },
      '155': {
        start: {
          line: 473,
          column: 6
        },
        end: {
          line: 473,
          column: 58
        }
      },
      '156': {
        start: {
          line: 476,
          column: 4
        },
        end: {
          line: 478,
          column: 5
        }
      },
      '157': {
        start: {
          line: 477,
          column: 6
        },
        end: {
          line: 477,
          column: 75
        }
      },
      '158': {
        start: {
          line: 481,
          column: 4
        },
        end: {
          line: 481,
          column: 50
        }
      },
      '159': {
        start: {
          line: 481,
          column: 23
        },
        end: {
          line: 481,
          column: 50
        }
      },
      '160': {
        start: {
          line: 489,
          column: 4
        },
        end: {
          line: 489,
          column: 63
        }
      },
      '161': {
        start: {
          line: 489,
          column: 23
        },
        end: {
          line: 489,
          column: 63
        }
      },
      '162': {
        start: {
          line: 489,
          column: 46
        },
        end: {
          line: 489,
          column: 62
        }
      },
      '163': {
        start: {
          line: 498,
          column: 4
        },
        end: {
          line: 498,
          column: 54
        }
      },
      '164': {
        start: {
          line: 498,
          column: 28
        },
        end: {
          line: 498,
          column: 52
        }
      },
      '165': {
        start: {
          line: 500,
          column: 4
        },
        end: {
          line: 500,
          column: 29
        }
      },
      '166': {
        start: {
          line: 508,
          column: 4
        },
        end: {
          line: 508,
          column: 17
        }
      },
      '167': {
        start: {
          line: 510,
          column: 4
        },
        end: {
          line: 510,
          column: 47
        }
      },
      '168': {
        start: {
          line: 511,
          column: 4
        },
        end: {
          line: 511,
          column: 82
        }
      },
      '169': {
        start: {
          line: 519,
          column: 24
        },
        end: {
          line: 519,
          column: 42
        }
      },
      '170': {
        start: {
          line: 520,
          column: 24
        },
        end: {
          line: 520,
          column: 46
        }
      },
      '171': {
        start: {
          line: 521,
          column: 24
        },
        end: {
          line: 521,
          column: 51
        }
      },
      '172': {
        start: {
          line: 522,
          column: 24
        },
        end: {
          line: 522,
          column: 47
        }
      },
      '173': {
        start: {
          line: 523,
          column: 24
        },
        end: {
          line: 523,
          column: 50
        }
      },
      '174': {
        start: {
          line: 524,
          column: 24
        },
        end: {
          line: 524,
          column: 55
        }
      },
      '175': {
        start: {
          line: 525,
          column: 24
        },
        end: {
          line: 525,
          column: 51
        }
      },
      '176': {
        start: {
          line: 526,
          column: 24
        },
        end: {
          line: 526,
          column: 52
        }
      },
      '177': {
        start: {
          line: 527,
          column: 24
        },
        end: {
          line: 527,
          column: 55
        }
      },
      '178': {
        start: {
          line: 534,
          column: 36
        },
        end: {
          line: 534,
          column: 87
        }
      },
      '179': {
        start: {
          line: 535,
          column: 36
        },
        end: {
          line: 535,
          column: 56
        }
      },
      '180': {
        start: {
          line: 536,
          column: 36
        },
        end: {
          line: 536,
          column: 56
        }
      },
      '181': {
        start: {
          line: 537,
          column: 36
        },
        end: {
          line: 537,
          column: 57
        }
      },
      '182': {
        start: {
          line: 538,
          column: 36
        },
        end: {
          line: 538,
          column: 60
        }
      },
      '183': {
        start: {
          line: 539,
          column: 36
        },
        end: {
          line: 539,
          column: 61
        }
      },
      '184': {
        start: {
          line: 540,
          column: 36
        },
        end: {
          line: 540,
          column: 62
        }
      },
      '185': {
        start: {
          line: 541,
          column: 36
        },
        end: {
          line: 541,
          column: 65
        }
      },
      '186': {
        start: {
          line: 545,
          column: 4
        },
        end: {
          line: 550,
          column: 5
        }
      },
      '187': {
        start: {
          line: 546,
          column: 6
        },
        end: {
          line: 546,
          column: 36
        }
      },
      '188': {
        start: {
          line: 548,
          column: 6
        },
        end: {
          line: 548,
          column: 42
        }
      },
      '189': {
        start: {
          line: 548,
          column: 36
        },
        end: {
          line: 548,
          column: 42
        }
      },
      '190': {
        start: {
          line: 549,
          column: 6
        },
        end: {
          line: 549,
          column: 113
        }
      },
      '191': {
        start: {
          line: 557,
          column: 4
        },
        end: {
          line: 557,
          column: 91
        }
      },
      '192': {
        start: {
          line: 569,
          column: 4
        },
        end: {
          line: 569,
          column: 46
        }
      },
      '193': {
        start: {
          line: 569,
          column: 40
        },
        end: {
          line: 569,
          column: 46
        }
      },
      '194': {
        start: {
          line: 570,
          column: 4
        },
        end: {
          line: 577,
          column: 5
        }
      },
      '195': {
        start: {
          line: 580,
          column: 4
        },
        end: {
          line: 586,
          column: 8
        }
      },
      '196': {
        start: {
          line: 581,
          column: 19
        },
        end: {
          line: 581,
          column: 31
        }
      },
      '197': {
        start: {
          line: 583,
          column: 8
        },
        end: {
          line: 583,
          column: 42
        }
      },
      '198': {
        start: {
          line: 584,
          column: 8
        },
        end: {
          line: 584,
          column: 40
        }
      },
      '199': {
        start: {
          line: 585,
          column: 8
        },
        end: {
          line: 585,
          column: 19
        }
      },
      '200': {
        start: {
          line: 590,
          column: 22
        },
        end: {
          line: 590,
          column: 36
        }
      },
      '201': {
        start: {
          line: 594,
          column: 4
        },
        end: {
          line: 594,
          column: 18
        }
      },
      '202': {
        start: {
          line: 598,
          column: 4
        },
        end: {
          line: 598,
          column: 50
        }
      },
      '203': {
        start: {
          line: 602,
          column: 4
        },
        end: {
          line: 602,
          column: 49
        }
      },
      '204': {
        start: {
          line: 621,
          column: 25
        },
        end: {
          line: 629,
          column: 1
        }
      },
      '205': {
        start: {
          line: 621,
          column: 38
        },
        end: {
          line: 629,
          column: 1
        }
      },
      '206': {
        start: {
          line: 622,
          column: 2
        },
        end: {
          line: 628,
          column: 3
        }
      },
      '207': {
        start: {
          line: 623,
          column: 4
        },
        end: {
          line: 623,
          column: 92
        }
      },
      '208': {
        start: {
          line: 623,
          column: 70
        },
        end: {
          line: 623,
          column: 90
        }
      },
      '209': {
        start: {
          line: 625,
          column: 4
        },
        end: {
          line: 625,
          column: 49
        }
      },
      '210': {
        start: {
          line: 627,
          column: 4
        },
        end: {
          line: 627,
          column: 34
        }
      },
      '211': {
        start: {
          line: 638,
          column: 22
        },
        end: {
          line: 654,
          column: 1
        }
      },
      '212': {
        start: {
          line: 639,
          column: 15
        },
        end: {
          line: 639,
          column: 68
        }
      },
      '213': {
        start: {
          line: 641,
          column: 2
        },
        end: {
          line: 653,
          column: 3
        }
      },
      '214': {
        start: {
          line: 642,
          column: 4
        },
        end: {
          line: 652,
          column: 5
        }
      },
      '215': {
        start: {
          line: 643,
          column: 6
        },
        end: {
          line: 647,
          column: 10
        }
      },
      '216': {
        start: {
          line: 645,
          column: 10
        },
        end: {
          line: 645,
          column: 30
        }
      },
      '217': {
        start: {
          line: 646,
          column: 10
        },
        end: {
          line: 646,
          column: 37
        }
      },
      '218': {
        start: {
          line: 650,
          column: 6
        },
        end: {
          line: 650,
          column: 40
        }
      },
      '219': {
        start: {
          line: 651,
          column: 6
        },
        end: {
          line: 651,
          column: 36
        }
      },
      '220': {
        start: {
          line: 662,
          column: 23
        },
        end: {
          line: 667,
          column: 1
        }
      },
      '221': {
        start: {
          line: 663,
          column: 13
        },
        end: {
          line: 663,
          column: 50
        }
      },
      '222': {
        start: {
          line: 664,
          column: 24
        },
        end: {
          line: 664,
          column: 72
        }
      },
      '223': {
        start: {
          line: 665,
          column: 19
        },
        end: {
          line: 665,
          column: 138
        }
      },
      '224': {
        start: {
          line: 666,
          column: 2
        },
        end: {
          line: 666,
          column: 57
        }
      }
    },
    fnMap: {
      '0': {
        name: '(anonymous_0)',
        decl: {
          start: {
            line: 42,
            column: 2
          },
          end: {
            line: 42,
            column: 3
          }
        },
        loc: {
          start: {
            line: 42,
            column: 35
          },
          end: {
            line: 92,
            column: 3
          }
        },
        line: 42
      },
      '1': {
        name: '(anonymous_1)',
        decl: {
          start: {
            line: 77,
            column: 20
          },
          end: {
            line: 77,
            column: 21
          }
        },
        loc: {
          start: {
            line: 77,
            column: 27
          },
          end: {
            line: 77,
            column: 123
          }
        },
        line: 77
      },
      '2': {
        name: '(anonymous_2)',
        decl: {
          start: {
            line: 81,
            column: 33
          },
          end: {
            line: 81,
            column: 34
          }
        },
        loc: {
          start: {
            line: 81,
            column: 47
          },
          end: {
            line: 86,
            column: 5
          }
        },
        line: 81
      },
      '3': {
        name: '(anonymous_3)',
        decl: {
          start: {
            line: 108,
            column: 2
          },
          end: {
            line: 108,
            column: 3
          }
        },
        loc: {
          start: {
            line: 108,
            column: 25
          },
          end: {
            line: 135,
            column: 3
          }
        },
        line: 108
      },
      '4': {
        name: '(anonymous_4)',
        decl: {
          start: {
            line: 110,
            column: 22
          },
          end: {
            line: 110,
            column: 23
          }
        },
        loc: {
          start: {
            line: 110,
            column: 28
          },
          end: {
            line: 114,
            column: 7
          }
        },
        line: 110
      },
      '5': {
        name: '(anonymous_5)',
        decl: {
          start: {
            line: 113,
            column: 47
          },
          end: {
            line: 113,
            column: 48
          }
        },
        loc: {
          start: {
            line: 113,
            column: 54
          },
          end: {
            line: 113,
            column: 73
          }
        },
        line: 113
      },
      '6': {
        name: '(anonymous_6)',
        decl: {
          start: {
            line: 115,
            column: 23
          },
          end: {
            line: 115,
            column: 24
          }
        },
        loc: {
          start: {
            line: 115,
            column: 34
          },
          end: {
            line: 120,
            column: 7
          }
        },
        line: 115
      },
      '7': {
        name: '(anonymous_7)',
        decl: {
          start: {
            line: 119,
            column: 47
          },
          end: {
            line: 119,
            column: 48
          }
        },
        loc: {
          start: {
            line: 119,
            column: 54
          },
          end: {
            line: 119,
            column: 65
          }
        },
        line: 119
      },
      '8': {
        name: '(anonymous_8)',
        decl: {
          start: {
            line: 121,
            column: 21
          },
          end: {
            line: 121,
            column: 22
          }
        },
        loc: {
          start: {
            line: 121,
            column: 36
          },
          end: {
            line: 125,
            column: 7
          }
        },
        line: 121
      },
      '9': {
        name: '(anonymous_9)',
        decl: {
          start: {
            line: 124,
            column: 47
          },
          end: {
            line: 124,
            column: 48
          }
        },
        loc: {
          start: {
            line: 124,
            column: 54
          },
          end: {
            line: 124,
            column: 65
          }
        },
        line: 124
      },
      '10': {
        name: '(anonymous_10)',
        decl: {
          start: {
            line: 126,
            column: 20
          },
          end: {
            line: 126,
            column: 21
          }
        },
        loc: {
          start: {
            line: 126,
            column: 30
          },
          end: {
            line: 130,
            column: 7
          }
        },
        line: 126
      },
      '11': {
        name: '(anonymous_11)',
        decl: {
          start: {
            line: 129,
            column: 47
          },
          end: {
            line: 129,
            column: 48
          }
        },
        loc: {
          start: {
            line: 129,
            column: 54
          },
          end: {
            line: 129,
            column: 65
          }
        },
        line: 129
      },
      '12': {
        name: '(anonymous_12)',
        decl: {
          start: {
            line: 146,
            column: 2
          },
          end: {
            line: 146,
            column: 3
          }
        },
        loc: {
          start: {
            line: 146,
            column: 21
          },
          end: {
            line: 188,
            column: 3
          }
        },
        line: 146
      },
      '13': {
        name: '(anonymous_13)',
        decl: {
          start: {
            line: 147,
            column: 26
          },
          end: {
            line: 147,
            column: 27
          }
        },
        loc: {
          start: {
            line: 147,
            column: 35
          },
          end: {
            line: 165,
            column: 5
          }
        },
        line: 147
      },
      '14': {
        name: '(anonymous_14)',
        decl: {
          start: {
            line: 155,
            column: 45
          },
          end: {
            line: 155,
            column: 46
          }
        },
        loc: {
          start: {
            line: 155,
            column: 58
          },
          end: {
            line: 161,
            column: 9
          }
        },
        line: 155
      },
      '15': {
        name: '(anonymous_15)',
        decl: {
          start: {
            line: 174,
            column: 32
          },
          end: {
            line: 174,
            column: 33
          }
        },
        loc: {
          start: {
            line: 174,
            column: 46
          },
          end: {
            line: 179,
            column: 7
          }
        },
        line: 174
      },
      '16': {
        name: '(anonymous_16)',
        decl: {
          start: {
            line: 176,
            column: 10
          },
          end: {
            line: 176,
            column: 11
          }
        },
        loc: {
          start: {
            line: 176,
            column: 19
          },
          end: {
            line: 176,
            column: 36
          }
        },
        line: 176
      },
      '17': {
        name: '(anonymous_17)',
        decl: {
          start: {
            line: 177,
            column: 10
          },
          end: {
            line: 177,
            column: 11
          }
        },
        loc: {
          start: {
            line: 177,
            column: 19
          },
          end: {
            line: 177,
            column: 36
          }
        },
        line: 177
      },
      '18': {
        name: '(anonymous_18)',
        decl: {
          start: {
            line: 181,
            column: 25
          },
          end: {
            line: 181,
            column: 26
          }
        },
        loc: {
          start: {
            line: 181,
            column: 46
          },
          end: {
            line: 186,
            column: 7
          }
        },
        line: 181
      },
      '19': {
        name: '(anonymous_19)',
        decl: {
          start: {
            line: 182,
            column: 34
          },
          end: {
            line: 182,
            column: 35
          }
        },
        loc: {
          start: {
            line: 182,
            column: 48
          },
          end: {
            line: 185,
            column: 9
          }
        },
        line: 182
      },
      '20': {
        name: '(anonymous_20)',
        decl: {
          start: {
            line: 199,
            column: 2
          },
          end: {
            line: 199,
            column: 3
          }
        },
        loc: {
          start: {
            line: 199,
            column: 25
          },
          end: {
            line: 202,
            column: 3
          }
        },
        line: 199
      },
      '21': {
        name: '(anonymous_21)',
        decl: {
          start: {
            line: 210,
            column: 2
          },
          end: {
            line: 210,
            column: 3
          }
        },
        loc: {
          start: {
            line: 210,
            column: 25
          },
          end: {
            line: 215,
            column: 3
          }
        },
        line: 210
      },
      '22': {
        name: '(anonymous_22)',
        decl: {
          start: {
            line: 211,
            column: 67
          },
          end: {
            line: 211,
            column: 68
          }
        },
        loc: {
          start: {
            line: 211,
            column: 74
          },
          end: {
            line: 214,
            column: 5
          }
        },
        line: 211
      },
      '23': {
        name: '(anonymous_23)',
        decl: {
          start: {
            line: 228,
            column: 2
          },
          end: {
            line: 228,
            column: 3
          }
        },
        loc: {
          start: {
            line: 228,
            column: 61
          },
          end: {
            line: 238,
            column: 3
          }
        },
        line: 228
      },
      '24': {
        name: '(anonymous_24)',
        decl: {
          start: {
            line: 234,
            column: 47
          },
          end: {
            line: 234,
            column: 48
          }
        },
        loc: {
          start: {
            line: 234,
            column: 54
          },
          end: {
            line: 234,
            column: 82
          }
        },
        line: 234
      },
      '25': {
        name: '(anonymous_25)',
        decl: {
          start: {
            line: 236,
            column: 51
          },
          end: {
            line: 236,
            column: 52
          }
        },
        loc: {
          start: {
            line: 236,
            column: 58
          },
          end: {
            line: 236,
            column: 86
          }
        },
        line: 236
      },
      '26': {
        name: '(anonymous_26)',
        decl: {
          start: {
            line: 260,
            column: 2
          },
          end: {
            line: 260,
            column: 3
          }
        },
        loc: {
          start: {
            line: 260,
            column: 17
          },
          end: {
            line: 267,
            column: 3
          }
        },
        line: 260
      },
      '27': {
        name: '(anonymous_27)',
        decl: {
          start: {
            line: 261,
            column: 25
          },
          end: {
            line: 261,
            column: 26
          }
        },
        loc: {
          start: {
            line: 261,
            column: 50
          },
          end: {
            line: 265,
            column: 5
          }
        },
        line: 261
      },
      '28': {
        name: '(anonymous_28)',
        decl: {
          start: {
            line: 290,
            column: 2
          },
          end: {
            line: 290,
            column: 3
          }
        },
        loc: {
          start: {
            line: 290,
            column: 51
          },
          end: {
            line: 302,
            column: 3
          }
        },
        line: 290
      },
      '29': {
        name: '(anonymous_29)',
        decl: {
          start: {
            line: 301,
            column: 12
          },
          end: {
            line: 301,
            column: 13
          }
        },
        loc: {
          start: {
            line: 301,
            column: 19
          },
          end: {
            line: 301,
            column: 47
          }
        },
        line: 301
      },
      '30': {
        name: '(anonymous_30)',
        decl: {
          start: {
            line: 326,
            column: 2
          },
          end: {
            line: 326,
            column: 3
          }
        },
        loc: {
          start: {
            line: 326,
            column: 87
          },
          end: {
            line: 337,
            column: 3
          }
        },
        line: 326
      },
      '31': {
        name: '(anonymous_31)',
        decl: {
          start: {
            line: 336,
            column: 12
          },
          end: {
            line: 336,
            column: 13
          }
        },
        loc: {
          start: {
            line: 336,
            column: 19
          },
          end: {
            line: 336,
            column: 47
          }
        },
        line: 336
      },
      '32': {
        name: '(anonymous_32)',
        decl: {
          start: {
            line: 346,
            column: 2
          },
          end: {
            line: 346,
            column: 3
          }
        },
        loc: {
          start: {
            line: 346,
            column: 74
          },
          end: {
            line: 353,
            column: 3
          }
        },
        line: 346
      },
      '33': {
        name: '(anonymous_33)',
        decl: {
          start: {
            line: 352,
            column: 75
          },
          end: {
            line: 352,
            column: 76
          }
        },
        loc: {
          start: {
            line: 352,
            column: 82
          },
          end: {
            line: 352,
            column: 110
          }
        },
        line: 352
      },
      '34': {
        name: '(anonymous_34)',
        decl: {
          start: {
            line: 362,
            column: 2
          },
          end: {
            line: 362,
            column: 3
          }
        },
        loc: {
          start: {
            line: 362,
            column: 60
          },
          end: {
            line: 370,
            column: 3
          }
        },
        line: 362
      },
      '35': {
        name: '(anonymous_35)',
        decl: {
          start: {
            line: 369,
            column: 64
          },
          end: {
            line: 369,
            column: 65
          }
        },
        loc: {
          start: {
            line: 369,
            column: 71
          },
          end: {
            line: 369,
            column: 99
          }
        },
        line: 369
      },
      '36': {
        name: '(anonymous_36)',
        decl: {
          start: {
            line: 397,
            column: 2
          },
          end: {
            line: 397,
            column: 3
          }
        },
        loc: {
          start: {
            line: 397,
            column: 72
          },
          end: {
            line: 414,
            column: 3
          }
        },
        line: 397
      },
      '37': {
        name: '(anonymous_37)',
        decl: {
          start: {
            line: 413,
            column: 12
          },
          end: {
            line: 413,
            column: 13
          }
        },
        loc: {
          start: {
            line: 413,
            column: 19
          },
          end: {
            line: 413,
            column: 47
          }
        },
        line: 413
      },
      '38': {
        name: '(anonymous_38)',
        decl: {
          start: {
            line: 436,
            column: 2
          },
          end: {
            line: 436,
            column: 3
          }
        },
        loc: {
          start: {
            line: 436,
            column: 74
          },
          end: {
            line: 445,
            column: 3
          }
        },
        line: 436
      },
      '39': {
        name: '(anonymous_39)',
        decl: {
          start: {
            line: 441,
            column: 59
          },
          end: {
            line: 441,
            column: 60
          }
        },
        loc: {
          start: {
            line: 441,
            column: 66
          },
          end: {
            line: 444,
            column: 5
          }
        },
        line: 441
      },
      '40': {
        name: '(anonymous_40)',
        decl: {
          start: {
            line: 454,
            column: 2
          },
          end: {
            line: 454,
            column: 3
          }
        },
        loc: {
          start: {
            line: 454,
            column: 19
          },
          end: {
            line: 482,
            column: 3
          }
        },
        line: 454
      },
      '41': {
        name: '(anonymous_41)',
        decl: {
          start: {
            line: 487,
            column: 2
          },
          end: {
            line: 487,
            column: 3
          }
        },
        loc: {
          start: {
            line: 487,
            column: 14
          },
          end: {
            line: 490,
            column: 3
          }
        },
        line: 487
      },
      '42': {
        name: '(anonymous_42)',
        decl: {
          start: {
            line: 489,
            column: 37
          },
          end: {
            line: 489,
            column: 38
          }
        },
        loc: {
          start: {
            line: 489,
            column: 46
          },
          end: {
            line: 489,
            column: 62
          }
        },
        line: 489
      },
      '43': {
        name: '(anonymous_43)',
        decl: {
          start: {
            line: 496,
            column: 2
          },
          end: {
            line: 496,
            column: 3
          }
        },
        loc: {
          start: {
            line: 496,
            column: 11
          },
          end: {
            line: 501,
            column: 3
          }
        },
        line: 496
      },
      '44': {
        name: '(anonymous_44)',
        decl: {
          start: {
            line: 498,
            column: 18
          },
          end: {
            line: 498,
            column: 19
          }
        },
        loc: {
          start: {
            line: 498,
            column: 28
          },
          end: {
            line: 498,
            column: 52
          }
        },
        line: 498
      },
      '45': {
        name: '(anonymous_45)',
        decl: {
          start: {
            line: 507,
            column: 2
          },
          end: {
            line: 507,
            column: 3
          }
        },
        loc: {
          start: {
            line: 507,
            column: 10
          },
          end: {
            line: 512,
            column: 3
          }
        },
        line: 507
      },
      '46': {
        name: '(anonymous_46)',
        decl: {
          start: {
            line: 519,
            column: 2
          },
          end: {
            line: 519,
            column: 3
          }
        },
        loc: {
          start: {
            line: 519,
            column: 22
          },
          end: {
            line: 519,
            column: 44
          }
        },
        line: 519
      },
      '47': {
        name: '(anonymous_47)',
        decl: {
          start: {
            line: 520,
            column: 2
          },
          end: {
            line: 520,
            column: 3
          }
        },
        loc: {
          start: {
            line: 520,
            column: 22
          },
          end: {
            line: 520,
            column: 48
          }
        },
        line: 520
      },
      '48': {
        name: '(anonymous_48)',
        decl: {
          start: {
            line: 521,
            column: 2
          },
          end: {
            line: 521,
            column: 3
          }
        },
        loc: {
          start: {
            line: 521,
            column: 22
          },
          end: {
            line: 521,
            column: 53
          }
        },
        line: 521
      },
      '49': {
        name: '(anonymous_49)',
        decl: {
          start: {
            line: 522,
            column: 2
          },
          end: {
            line: 522,
            column: 3
          }
        },
        loc: {
          start: {
            line: 522,
            column: 22
          },
          end: {
            line: 522,
            column: 49
          }
        },
        line: 522
      },
      '50': {
        name: '(anonymous_50)',
        decl: {
          start: {
            line: 523,
            column: 2
          },
          end: {
            line: 523,
            column: 3
          }
        },
        loc: {
          start: {
            line: 523,
            column: 22
          },
          end: {
            line: 523,
            column: 52
          }
        },
        line: 523
      },
      '51': {
        name: '(anonymous_51)',
        decl: {
          start: {
            line: 524,
            column: 2
          },
          end: {
            line: 524,
            column: 3
          }
        },
        loc: {
          start: {
            line: 524,
            column: 22
          },
          end: {
            line: 524,
            column: 57
          }
        },
        line: 524
      },
      '52': {
        name: '(anonymous_52)',
        decl: {
          start: {
            line: 525,
            column: 2
          },
          end: {
            line: 525,
            column: 3
          }
        },
        loc: {
          start: {
            line: 525,
            column: 22
          },
          end: {
            line: 525,
            column: 53
          }
        },
        line: 525
      },
      '53': {
        name: '(anonymous_53)',
        decl: {
          start: {
            line: 526,
            column: 2
          },
          end: {
            line: 526,
            column: 3
          }
        },
        loc: {
          start: {
            line: 526,
            column: 22
          },
          end: {
            line: 526,
            column: 54
          }
        },
        line: 526
      },
      '54': {
        name: '(anonymous_54)',
        decl: {
          start: {
            line: 527,
            column: 2
          },
          end: {
            line: 527,
            column: 3
          }
        },
        loc: {
          start: {
            line: 527,
            column: 22
          },
          end: {
            line: 527,
            column: 57
          }
        },
        line: 527
      },
      '55': {
        name: '(anonymous_55)',
        decl: {
          start: {
            line: 534,
            column: 2
          },
          end: {
            line: 534,
            column: 3
          }
        },
        loc: {
          start: {
            line: 534,
            column: 34
          },
          end: {
            line: 534,
            column: 89
          }
        },
        line: 534
      },
      '56': {
        name: '(anonymous_56)',
        decl: {
          start: {
            line: 535,
            column: 2
          },
          end: {
            line: 535,
            column: 3
          }
        },
        loc: {
          start: {
            line: 535,
            column: 34
          },
          end: {
            line: 535,
            column: 58
          }
        },
        line: 535
      },
      '57': {
        name: '(anonymous_57)',
        decl: {
          start: {
            line: 536,
            column: 2
          },
          end: {
            line: 536,
            column: 3
          }
        },
        loc: {
          start: {
            line: 536,
            column: 34
          },
          end: {
            line: 536,
            column: 58
          }
        },
        line: 536
      },
      '58': {
        name: '(anonymous_58)',
        decl: {
          start: {
            line: 537,
            column: 2
          },
          end: {
            line: 537,
            column: 3
          }
        },
        loc: {
          start: {
            line: 537,
            column: 34
          },
          end: {
            line: 537,
            column: 59
          }
        },
        line: 537
      },
      '59': {
        name: '(anonymous_59)',
        decl: {
          start: {
            line: 538,
            column: 2
          },
          end: {
            line: 538,
            column: 3
          }
        },
        loc: {
          start: {
            line: 538,
            column: 34
          },
          end: {
            line: 538,
            column: 62
          }
        },
        line: 538
      },
      '60': {
        name: '(anonymous_60)',
        decl: {
          start: {
            line: 539,
            column: 2
          },
          end: {
            line: 539,
            column: 3
          }
        },
        loc: {
          start: {
            line: 539,
            column: 34
          },
          end: {
            line: 539,
            column: 63
          }
        },
        line: 539
      },
      '61': {
        name: '(anonymous_61)',
        decl: {
          start: {
            line: 540,
            column: 2
          },
          end: {
            line: 540,
            column: 3
          }
        },
        loc: {
          start: {
            line: 540,
            column: 34
          },
          end: {
            line: 540,
            column: 64
          }
        },
        line: 540
      },
      '62': {
        name: '(anonymous_62)',
        decl: {
          start: {
            line: 541,
            column: 2
          },
          end: {
            line: 541,
            column: 3
          }
        },
        loc: {
          start: {
            line: 541,
            column: 34
          },
          end: {
            line: 541,
            column: 67
          }
        },
        line: 541
      },
      '63': {
        name: '(anonymous_63)',
        decl: {
          start: {
            line: 544,
            column: 2
          },
          end: {
            line: 544,
            column: 3
          }
        },
        loc: {
          start: {
            line: 544,
            column: 24
          },
          end: {
            line: 551,
            column: 3
          }
        },
        line: 544
      },
      '64': {
        name: '(anonymous_64)',
        decl: {
          start: {
            line: 556,
            column: 2
          },
          end: {
            line: 556,
            column: 3
          }
        },
        loc: {
          start: {
            line: 556,
            column: 22
          },
          end: {
            line: 558,
            column: 3
          }
        },
        line: 556
      },
      '65': {
        name: '(anonymous_65)',
        decl: {
          start: {
            line: 568,
            column: 2
          },
          end: {
            line: 568,
            column: 3
          }
        },
        loc: {
          start: {
            line: 568,
            column: 33
          },
          end: {
            line: 587,
            column: 3
          }
        },
        line: 568
      },
      '66': {
        name: '(anonymous_66)',
        decl: {
          start: {
            line: 581,
            column: 12
          },
          end: {
            line: 581,
            column: 13
          }
        },
        loc: {
          start: {
            line: 581,
            column: 19
          },
          end: {
            line: 581,
            column: 31
          }
        },
        line: 581
      },
      '67': {
        name: '(anonymous_67)',
        decl: {
          start: {
            line: 582,
            column: 12
          },
          end: {
            line: 582,
            column: 13
          }
        },
        loc: {
          start: {
            line: 582,
            column: 20
          },
          end: {
            line: 586,
            column: 7
          }
        },
        line: 582
      },
      '68': {
        name: '(anonymous_68)',
        decl: {
          start: {
            line: 593,
            column: 2
          },
          end: {
            line: 593,
            column: 3
          }
        },
        loc: {
          start: {
            line: 593,
            column: 36
          },
          end: {
            line: 595,
            column: 3
          }
        },
        line: 593
      },
      '69': {
        name: '(anonymous_69)',
        decl: {
          start: {
            line: 597,
            column: 2
          },
          end: {
            line: 597,
            column: 3
          }
        },
        loc: {
          start: {
            line: 597,
            column: 8
          },
          end: {
            line: 599,
            column: 3
          }
        },
        line: 597
      },
      '70': {
        name: '(anonymous_70)',
        decl: {
          start: {
            line: 601,
            column: 2
          },
          end: {
            line: 601,
            column: 3
          }
        },
        loc: {
          start: {
            line: 601,
            column: 16
          },
          end: {
            line: 603,
            column: 3
          }
        },
        line: 601
      },
      '71': {
        name: '(anonymous_71)',
        decl: {
          start: {
            line: 621,
            column: 25
          },
          end: {
            line: 621,
            column: 26
          }
        },
        loc: {
          start: {
            line: 621,
            column: 38
          },
          end: {
            line: 629,
            column: 1
          }
        },
        line: 621
      },
      '72': {
        name: '(anonymous_72)',
        decl: {
          start: {
            line: 621,
            column: 38
          },
          end: {
            line: 621,
            column: 39
          }
        },
        loc: {
          start: {
            line: 621,
            column: 67
          },
          end: {
            line: 629,
            column: 1
          }
        },
        line: 621
      },
      '73': {
        name: '(anonymous_73)',
        decl: {
          start: {
            line: 623,
            column: 62
          },
          end: {
            line: 623,
            column: 63
          }
        },
        loc: {
          start: {
            line: 623,
            column: 70
          },
          end: {
            line: 623,
            column: 90
          }
        },
        line: 623
      },
      '74': {
        name: '(anonymous_74)',
        decl: {
          start: {
            line: 638,
            column: 22
          },
          end: {
            line: 638,
            column: 23
          }
        },
        loc: {
          start: {
            line: 638,
            column: 51
          },
          end: {
            line: 654,
            column: 1
          }
        },
        line: 638
      },
      '75': {
        name: '(anonymous_75)',
        decl: {
          start: {
            line: 641,
            column: 9
          },
          end: {
            line: 641,
            column: 10
          }
        },
        loc: {
          start: {
            line: 641,
            column: 50
          },
          end: {
            line: 653,
            column: 3
          }
        },
        line: 641
      },
      '76': {
        name: '(anonymous_76)',
        decl: {
          start: {
            line: 644,
            column: 14
          },
          end: {
            line: 644,
            column: 15
          }
        },
        loc: {
          start: {
            line: 644,
            column: 21
          },
          end: {
            line: 647,
            column: 9
          }
        },
        line: 644
      },
      '77': {
        name: '(anonymous_77)',
        decl: {
          start: {
            line: 662,
            column: 23
          },
          end: {
            line: 662,
            column: 24
          }
        },
        loc: {
          start: {
            line: 662,
            column: 31
          },
          end: {
            line: 667,
            column: 1
          }
        },
        line: 662
      }
    },
    branchMap: {
      '0': {
        loc: {
          start: {
            line: 42,
            column: 24
          },
          end: {
            line: 42,
            column: 33
          }
        },
        type: 'default-arg',
        locations: [{
          start: {
            line: 42,
            column: 31
          },
          end: {
            line: 42,
            column: 33
          }
        }],
        line: 42
      },
      '1': {
        loc: {
          start: {
            line: 44,
            column: 19
          },
          end: {
            line: 44,
            column: 49
          }
        },
        type: 'binary-expr',
        locations: [{
          start: {
            line: 44,
            column: 19
          },
          end: {
            line: 44,
            column: 26
          }
        }, {
          start: {
            line: 44,
            column: 30
          },
          end: {
            line: 44,
            column: 49
          }
        }],
        line: 44
      },
      '2': {
        loc: {
          start: {
            line: 50,
            column: 23
          },
          end: {
            line: 50,
            column: 81
          }
        },
        type: 'cond-expr',
        locations: [{
          start: {
            line: 50,
            column: 53
          },
          end: {
            line: 50,
            column: 62
          }
        }, {
          start: {
            line: 50,
            column: 65
          },
          end: {
            line: 50,
            column: 81
          }
        }],
        line: 50
      },
      '3': {
        loc: {
          start: {
            line: 51,
            column: 22
          },
          end: {
            line: 51,
            column: 78
          }
        },
        type: 'cond-expr',
        locations: [{
          start: {
            line: 51,
            column: 52
          },
          end: {
            line: 51,
            column: 62
          }
        }, {
          start: {
            line: 51,
            column: 65
          },
          end: {
            line: 51,
            column: 78
          }
        }],
        line: 51
      },
      '4': {
        loc: {
          start: {
            line: 52,
            column: 20
          },
          end: {
            line: 52,
            column: 70
          }
        },
        type: 'cond-expr',
        locations: [{
          start: {
            line: 52,
            column: 50
          },
          end: {
            line: 52,
            column: 54
          }
        }, {
          start: {
            line: 52,
            column: 57
          },
          end: {
            line: 52,
            column: 70
          }
        }],
        line: 52
      },
      '5': {
        loc: {
          start: {
            line: 53,
            column: 19
          },
          end: {
            line: 53,
            column: 67
          }
        },
        type: 'cond-expr',
        locations: [{
          start: {
            line: 53,
            column: 48
          },
          end: {
            line: 53,
            column: 52
          }
        }, {
          start: {
            line: 53,
            column: 55
          },
          end: {
            line: 53,
            column: 67
          }
        }],
        line: 53
      },
      '6': {
        loc: {
          start: {
            line: 54,
            column: 14
          },
          end: {
            line: 54,
            column: 51
          }
        },
        type: 'cond-expr',
        locations: [{
          start: {
            line: 54,
            column: 39
          },
          end: {
            line: 54,
            column: 46
          }
        }, {
          start: {
            line: 54,
            column: 49
          },
          end: {
            line: 54,
            column: 51
          }
        }],
        line: 54
      },
      '7': {
        loc: {
          start: {
            line: 57,
            column: 4
          },
          end: {
            line: 59,
            column: 5
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 57,
            column: 4
          },
          end: {
            line: 59,
            column: 5
          }
        }, {
          start: {
            line: 57,
            column: 4
          },
          end: {
            line: 59,
            column: 5
          }
        }],
        line: 57
      },
      '8': {
        loc: {
          start: {
            line: 57,
            column: 8
          },
          end: {
            line: 57,
            column: 95
          }
        },
        type: 'binary-expr',
        locations: [{
          start: {
            line: 57,
            column: 8
          },
          end: {
            line: 57,
            column: 58
          }
        }, {
          start: {
            line: 57,
            column: 62
          },
          end: {
            line: 57,
            column: 95
          }
        }],
        line: 57
      },
      '9': {
        loc: {
          start: {
            line: 62,
            column: 17
          },
          end: {
            line: 62,
            column: 54
          }
        },
        type: 'binary-expr',
        locations: [{
          start: {
            line: 62,
            column: 17
          },
          end: {
            line: 62,
            column: 27
          }
        }, {
          start: {
            line: 62,
            column: 31
          },
          end: {
            line: 62,
            column: 54
          }
        }],
        line: 62
      },
      '10': {
        loc: {
          start: {
            line: 68,
            column: 4
          },
          end: {
            line: 68,
            column: 39
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 68,
            column: 4
          },
          end: {
            line: 68,
            column: 39
          }
        }, {
          start: {
            line: 68,
            column: 4
          },
          end: {
            line: 68,
            column: 39
          }
        }],
        line: 68
      },
      '11': {
        loc: {
          start: {
            line: 69,
            column: 4
          },
          end: {
            line: 69,
            column: 70
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 69,
            column: 4
          },
          end: {
            line: 69,
            column: 70
          }
        }, {
          start: {
            line: 69,
            column: 4
          },
          end: {
            line: 69,
            column: 70
          }
        }],
        line: 69
      },
      '12': {
        loc: {
          start: {
            line: 73,
            column: 21
          },
          end: {
            line: 73,
            column: 64
          }
        },
        type: 'binary-expr',
        locations: [{
          start: {
            line: 73,
            column: 21
          },
          end: {
            line: 73,
            column: 35
          }
        }, {
          start: {
            line: 73,
            column: 39
          },
          end: {
            line: 73,
            column: 64
          }
        }],
        line: 73
      },
      '13': {
        loc: {
          start: {
            line: 75,
            column: 27
          },
          end: {
            line: 78,
            column: 6
          }
        },
        type: 'binary-expr',
        locations: [{
          start: {
            line: 75,
            column: 27
          },
          end: {
            line: 75,
            column: 47
          }
        }, {
          start: {
            line: 75,
            column: 51
          },
          end: {
            line: 78,
            column: 6
          }
        }],
        line: 75
      },
      '14': {
        loc: {
          start: {
            line: 77,
            column: 27
          },
          end: {
            line: 77,
            column: 123
          }
        },
        type: 'cond-expr',
        locations: [{
          start: {
            line: 77,
            column: 47
          },
          end: {
            line: 77,
            column: 83
          }
        }, {
          start: {
            line: 77,
            column: 86
          },
          end: {
            line: 77,
            column: 123
          }
        }],
        line: 77
      },
      '15': {
        loc: {
          start: {
            line: 79,
            column: 26
          },
          end: {
            line: 79,
            column: 76
          }
        },
        type: 'binary-expr',
        locations: [{
          start: {
            line: 79,
            column: 26
          },
          end: {
            line: 79,
            column: 45
          }
        }, {
          start: {
            line: 79,
            column: 49
          },
          end: {
            line: 79,
            column: 76
          }
        }],
        line: 79
      },
      '16': {
        loc: {
          start: {
            line: 80,
            column: 25
          },
          end: {
            line: 80,
            column: 125
          }
        },
        type: 'cond-expr',
        locations: [{
          start: {
            line: 80,
            column: 65
          },
          end: {
            line: 80,
            column: 113
          }
        }, {
          start: {
            line: 80,
            column: 116
          },
          end: {
            line: 80,
            column: 125
          }
        }],
        line: 80
      },
      '17': {
        loc: {
          start: {
            line: 80,
            column: 26
          },
          end: {
            line: 80,
            column: 61
          }
        },
        type: 'binary-expr',
        locations: [{
          start: {
            line: 80,
            column: 26
          },
          end: {
            line: 80,
            column: 40
          }
        }, {
          start: {
            line: 80,
            column: 44
          },
          end: {
            line: 80,
            column: 61
          }
        }],
        line: 80
      },
      '18': {
        loc: {
          start: {
            line: 82,
            column: 6
          },
          end: {
            line: 82,
            column: 24
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 82,
            column: 6
          },
          end: {
            line: 82,
            column: 24
          }
        }, {
          start: {
            line: 82,
            column: 6
          },
          end: {
            line: 82,
            column: 24
          }
        }],
        line: 82
      },
      '19': {
        loc: {
          start: {
            line: 89,
            column: 20
          },
          end: {
            line: 89,
            column: 110
          }
        },
        type: 'binary-expr',
        locations: [{
          start: {
            line: 89,
            column: 20
          },
          end: {
            line: 89,
            column: 33
          }
        }, {
          start: {
            line: 89,
            column: 37
          },
          end: {
            line: 89,
            column: 110
          }
        }],
        line: 89
      },
      '20': {
        loc: {
          start: {
            line: 112,
            column: 45
          },
          end: {
            line: 112,
            column: 74
          }
        },
        type: 'binary-expr',
        locations: [{
          start: {
            line: 112,
            column: 45
          },
          end: {
            line: 112,
            column: 61
          }
        }, {
          start: {
            line: 112,
            column: 65
          },
          end: {
            line: 112,
            column: 74
          }
        }],
        line: 112
      },
      '21': {
        loc: {
          start: {
            line: 133,
            column: 4
          },
          end: {
            line: 133,
            column: 58
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 133,
            column: 4
          },
          end: {
            line: 133,
            column: 58
          }
        }, {
          start: {
            line: 133,
            column: 4
          },
          end: {
            line: 133,
            column: 58
          }
        }],
        line: 133
      },
      '22': {
        loc: {
          start: {
            line: 148,
            column: 6
          },
          end: {
            line: 148,
            column: 68
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 148,
            column: 6
          },
          end: {
            line: 148,
            column: 68
          }
        }, {
          start: {
            line: 148,
            column: 6
          },
          end: {
            line: 148,
            column: 68
          }
        }],
        line: 148
      },
      '23': {
        loc: {
          start: {
            line: 149,
            column: 6
          },
          end: {
            line: 164,
            column: 7
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 149,
            column: 6
          },
          end: {
            line: 164,
            column: 7
          }
        }, {
          start: {
            line: 149,
            column: 6
          },
          end: {
            line: 164,
            column: 7
          }
        }],
        line: 149
      },
      '24': {
        loc: {
          start: {
            line: 152,
            column: 8
          },
          end: {
            line: 154,
            column: 9
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 152,
            column: 8
          },
          end: {
            line: 154,
            column: 9
          }
        }, {
          start: {
            line: 152,
            column: 8
          },
          end: {
            line: 154,
            column: 9
          }
        }],
        line: 152
      },
      '25': {
        loc: {
          start: {
            line: 158,
            column: 10
          },
          end: {
            line: 158,
            column: 73
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 158,
            column: 10
          },
          end: {
            line: 158,
            column: 73
          }
        }, {
          start: {
            line: 158,
            column: 10
          },
          end: {
            line: 158,
            column: 73
          }
        }],
        line: 158
      },
      '26': {
        loc: {
          start: {
            line: 167,
            column: 4
          },
          end: {
            line: 171,
            column: 5
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 167,
            column: 4
          },
          end: {
            line: 171,
            column: 5
          }
        }, {
          start: {
            line: 167,
            column: 4
          },
          end: {
            line: 171,
            column: 5
          }
        }],
        line: 167
      },
      '27': {
        loc: {
          start: {
            line: 167,
            column: 8
          },
          end: {
            line: 167,
            column: 60
          }
        },
        type: 'binary-expr',
        locations: [{
          start: {
            line: 167,
            column: 8
          },
          end: {
            line: 167,
            column: 27
          }
        }, {
          start: {
            line: 167,
            column: 31
          },
          end: {
            line: 167,
            column: 60
          }
        }],
        line: 167
      },
      '28': {
        loc: {
          start: {
            line: 173,
            column: 4
          },
          end: {
            line: 187,
            column: 5
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 173,
            column: 4
          },
          end: {
            line: 187,
            column: 5
          }
        }, {
          start: {
            line: 173,
            column: 4
          },
          end: {
            line: 187,
            column: 5
          }
        }],
        line: 173
      },
      '29': {
        loc: {
          start: {
            line: 200,
            column: 4
          },
          end: {
            line: 200,
            column: 85
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 200,
            column: 4
          },
          end: {
            line: 200,
            column: 85
          }
        }, {
          start: {
            line: 200,
            column: 4
          },
          end: {
            line: 200,
            column: 85
          }
        }],
        line: 200
      },
      '30': {
        loc: {
          start: {
            line: 200,
            column: 8
          },
          end: {
            line: 200,
            column: 33
          }
        },
        type: 'binary-expr',
        locations: [{
          start: {
            line: 200,
            column: 8
          },
          end: {
            line: 200,
            column: 17
          }
        }, {
          start: {
            line: 200,
            column: 21
          },
          end: {
            line: 200,
            column: 33
          }
        }],
        line: 200
      },
      '31': {
        loc: {
          start: {
            line: 228,
            column: 21
          },
          end: {
            line: 228,
            column: 59
          }
        },
        type: 'default-arg',
        locations: [{
          start: {
            line: 228,
            column: 57
          },
          end: {
            line: 228,
            column: 59
          }
        }],
        line: 228
      },
      '32': {
        loc: {
          start: {
            line: 229,
            column: 4
          },
          end: {
            line: 229,
            column: 51
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 229,
            column: 4
          },
          end: {
            line: 229,
            column: 51
          }
        }, {
          start: {
            line: 229,
            column: 4
          },
          end: {
            line: 229,
            column: 51
          }
        }],
        line: 229
      },
      '33': {
        loc: {
          start: {
            line: 230,
            column: 4
          },
          end: {
            line: 237,
            column: 5
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 230,
            column: 4
          },
          end: {
            line: 237,
            column: 5
          }
        }, {
          start: {
            line: 230,
            column: 4
          },
          end: {
            line: 237,
            column: 5
          }
        }],
        line: 230
      },
      '34': {
        loc: {
          start: {
            line: 231,
            column: 6
          },
          end: {
            line: 231,
            column: 49
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 231,
            column: 6
          },
          end: {
            line: 231,
            column: 49
          }
        }, {
          start: {
            line: 231,
            column: 6
          },
          end: {
            line: 231,
            column: 49
          }
        }],
        line: 231
      },
      '35': {
        loc: {
          start: {
            line: 233,
            column: 11
          },
          end: {
            line: 237,
            column: 5
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 233,
            column: 11
          },
          end: {
            line: 237,
            column: 5
          }
        }, {
          start: {
            line: 233,
            column: 11
          },
          end: {
            line: 237,
            column: 5
          }
        }],
        line: 233
      },
      '36': {
        loc: {
          start: {
            line: 233,
            column: 15
          },
          end: {
            line: 233,
            column: 49
          }
        },
        type: 'binary-expr',
        locations: [{
          start: {
            line: 233,
            column: 15
          },
          end: {
            line: 233,
            column: 27
          }
        }, {
          start: {
            line: 233,
            column: 31
          },
          end: {
            line: 233,
            column: 49
          }
        }],
        line: 233
      },
      '37': {
        loc: {
          start: {
            line: 290,
            column: 25
          },
          end: {
            line: 290,
            column: 35
          }
        },
        type: 'default-arg',
        locations: [{
          start: {
            line: 290,
            column: 33
          },
          end: {
            line: 290,
            column: 35
          }
        }],
        line: 290
      },
      '38': {
        loc: {
          start: {
            line: 291,
            column: 4
          },
          end: {
            line: 291,
            column: 52
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 291,
            column: 4
          },
          end: {
            line: 291,
            column: 52
          }
        }, {
          start: {
            line: 291,
            column: 4
          },
          end: {
            line: 291,
            column: 52
          }
        }],
        line: 291
      },
      '39': {
        loc: {
          start: {
            line: 294,
            column: 10
          },
          end: {
            line: 294,
            column: 93
          }
        },
        type: 'cond-expr',
        locations: [{
          start: {
            line: 294,
            column: 29
          },
          end: {
            line: 294,
            column: 37
          }
        }, {
          start: {
            line: 294,
            column: 40
          },
          end: {
            line: 294,
            column: 93
          }
        }],
        line: 294
      },
      '40': {
        loc: {
          start: {
            line: 299,
            column: 4
          },
          end: {
            line: 299,
            column: 61
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 299,
            column: 4
          },
          end: {
            line: 299,
            column: 61
          }
        }, {
          start: {
            line: 299,
            column: 4
          },
          end: {
            line: 299,
            column: 61
          }
        }],
        line: 299
      },
      '41': {
        loc: {
          start: {
            line: 299,
            column: 18
          },
          end: {
            line: 299,
            column: 61
          }
        },
        type: 'cond-expr',
        locations: [{
          start: {
            line: 299,
            column: 29
          },
          end: {
            line: 299,
            column: 51
          }
        }, {
          start: {
            line: 299,
            column: 54
          },
          end: {
            line: 299,
            column: 61
          }
        }],
        line: 299
      },
      '42': {
        loc: {
          start: {
            line: 326,
            column: 59
          },
          end: {
            line: 326,
            column: 75
          }
        },
        type: 'default-arg',
        locations: [{
          start: {
            line: 326,
            column: 64
          },
          end: {
            line: 326,
            column: 75
          }
        }],
        line: 326
      },
      '43': {
        loc: {
          start: {
            line: 328,
            column: 4
          },
          end: {
            line: 333,
            column: 5
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 328,
            column: 4
          },
          end: {
            line: 333,
            column: 5
          }
        }, {
          start: {
            line: 328,
            column: 4
          },
          end: {
            line: 333,
            column: 5
          }
        }],
        line: 328
      },
      '44': {
        loc: {
          start: {
            line: 331,
            column: 11
          },
          end: {
            line: 333,
            column: 5
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 331,
            column: 11
          },
          end: {
            line: 333,
            column: 5
          }
        }, {
          start: {
            line: 331,
            column: 11
          },
          end: {
            line: 333,
            column: 5
          }
        }],
        line: 331
      },
      '45': {
        loc: {
          start: {
            line: 331,
            column: 15
          },
          end: {
            line: 331,
            column: 33
          }
        },
        type: 'binary-expr',
        locations: [{
          start: {
            line: 331,
            column: 15
          },
          end: {
            line: 331,
            column: 20
          }
        }, {
          start: {
            line: 331,
            column: 24
          },
          end: {
            line: 331,
            column: 33
          }
        }],
        line: 331
      },
      '46': {
        loc: {
          start: {
            line: 346,
            column: 40
          },
          end: {
            line: 346,
            column: 62
          }
        },
        type: 'default-arg',
        locations: [{
          start: {
            line: 346,
            column: 45
          },
          end: {
            line: 346,
            column: 62
          }
        }],
        line: 346
      },
      '47': {
        loc: {
          start: {
            line: 351,
            column: 4
          },
          end: {
            line: 351,
            column: 46
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 351,
            column: 4
          },
          end: {
            line: 351,
            column: 46
          }
        }, {
          start: {
            line: 351,
            column: 4
          },
          end: {
            line: 351,
            column: 46
          }
        }],
        line: 351
      },
      '48': {
        loc: {
          start: {
            line: 362,
            column: 28
          },
          end: {
            line: 362,
            column: 48
          }
        },
        type: 'default-arg',
        locations: [{
          start: {
            line: 362,
            column: 31
          },
          end: {
            line: 362,
            column: 48
          }
        }],
        line: 362
      },
      '49': {
        loc: {
          start: {
            line: 367,
            column: 4
          },
          end: {
            line: 367,
            column: 46
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 367,
            column: 4
          },
          end: {
            line: 367,
            column: 46
          }
        }, {
          start: {
            line: 367,
            column: 4
          },
          end: {
            line: 367,
            column: 46
          }
        }],
        line: 367
      },
      '50': {
        loc: {
          start: {
            line: 397,
            column: 27
          },
          end: {
            line: 397,
            column: 38
          }
        },
        type: 'default-arg',
        locations: [{
          start: {
            line: 397,
            column: 36
          },
          end: {
            line: 397,
            column: 38
          }
        }],
        line: 397
      },
      '51': {
        loc: {
          start: {
            line: 397,
            column: 40
          },
          end: {
            line: 397,
            column: 60
          }
        },
        type: 'default-arg',
        locations: [{
          start: {
            line: 397,
            column: 45
          },
          end: {
            line: 397,
            column: 60
          }
        }],
        line: 397
      },
      '52': {
        loc: {
          start: {
            line: 398,
            column: 4
          },
          end: {
            line: 398,
            column: 53
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 398,
            column: 4
          },
          end: {
            line: 398,
            column: 53
          }
        }, {
          start: {
            line: 398,
            column: 4
          },
          end: {
            line: 398,
            column: 53
          }
        }],
        line: 398
      },
      '53': {
        loc: {
          start: {
            line: 402,
            column: 19
          },
          end: {
            line: 402,
            column: 45
          }
        },
        type: 'binary-expr',
        locations: [{
          start: {
            line: 402,
            column: 19
          },
          end: {
            line: 402,
            column: 35
          }
        }, {
          start: {
            line: 402,
            column: 39
          },
          end: {
            line: 402,
            column: 45
          }
        }],
        line: 402
      },
      '54': {
        loc: {
          start: {
            line: 406,
            column: 4
          },
          end: {
            line: 409,
            column: 5
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 406,
            column: 4
          },
          end: {
            line: 409,
            column: 5
          }
        }, {
          start: {
            line: 406,
            column: 4
          },
          end: {
            line: 409,
            column: 5
          }
        }],
        line: 406
      },
      '55': {
        loc: {
          start: {
            line: 436,
            column: 26
          },
          end: {
            line: 436,
            column: 43
          }
        },
        type: 'default-arg',
        locations: [{
          start: {
            line: 436,
            column: 41
          },
          end: {
            line: 436,
            column: 43
          }
        }],
        line: 436
      },
      '56': {
        loc: {
          start: {
            line: 436,
            column: 45
          },
          end: {
            line: 436,
            column: 62
          }
        },
        type: 'default-arg',
        locations: [{
          start: {
            line: 436,
            column: 50
          },
          end: {
            line: 436,
            column: 62
          }
        }],
        line: 436
      },
      '57': {
        loc: {
          start: {
            line: 437,
            column: 4
          },
          end: {
            line: 437,
            column: 59
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 437,
            column: 4
          },
          end: {
            line: 437,
            column: 59
          }
        }, {
          start: {
            line: 437,
            column: 4
          },
          end: {
            line: 437,
            column: 59
          }
        }],
        line: 437
      },
      '58': {
        loc: {
          start: {
            line: 455,
            column: 4
          },
          end: {
            line: 466,
            column: 5
          }
        },
        type: 'switch',
        locations: [{
          start: {
            line: 456,
            column: 6
          },
          end: {
            line: 458,
            column: 13
          }
        }, {
          start: {
            line: 459,
            column: 6
          },
          end: {
            line: 461,
            column: 13
          }
        }, {
          start: {
            line: 462,
            column: 6
          },
          end: {
            line: 463,
            column: 13
          }
        }, {
          start: {
            line: 464,
            column: 6
          },
          end: {
            line: 465,
            column: 61
          }
        }],
        line: 455
      },
      '59': {
        loc: {
          start: {
            line: 469,
            column: 4
          },
          end: {
            line: 474,
            column: 5
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 469,
            column: 4
          },
          end: {
            line: 474,
            column: 5
          }
        }, {
          start: {
            line: 469,
            column: 4
          },
          end: {
            line: 474,
            column: 5
          }
        }],
        line: 469
      },
      '60': {
        loc: {
          start: {
            line: 471,
            column: 11
          },
          end: {
            line: 474,
            column: 5
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 471,
            column: 11
          },
          end: {
            line: 474,
            column: 5
          }
        }, {
          start: {
            line: 471,
            column: 11
          },
          end: {
            line: 474,
            column: 5
          }
        }],
        line: 471
      },
      '61': {
        loc: {
          start: {
            line: 476,
            column: 4
          },
          end: {
            line: 478,
            column: 5
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 476,
            column: 4
          },
          end: {
            line: 478,
            column: 5
          }
        }, {
          start: {
            line: 476,
            column: 4
          },
          end: {
            line: 478,
            column: 5
          }
        }],
        line: 476
      },
      '62': {
        loc: {
          start: {
            line: 476,
            column: 8
          },
          end: {
            line: 476,
            column: 43
          }
        },
        type: 'binary-expr',
        locations: [{
          start: {
            line: 476,
            column: 8
          },
          end: {
            line: 476,
            column: 25
          }
        }, {
          start: {
            line: 476,
            column: 29
          },
          end: {
            line: 476,
            column: 43
          }
        }],
        line: 476
      },
      '63': {
        loc: {
          start: {
            line: 481,
            column: 4
          },
          end: {
            line: 481,
            column: 50
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 481,
            column: 4
          },
          end: {
            line: 481,
            column: 50
          }
        }, {
          start: {
            line: 481,
            column: 4
          },
          end: {
            line: 481,
            column: 50
          }
        }],
        line: 481
      },
      '64': {
        loc: {
          start: {
            line: 489,
            column: 4
          },
          end: {
            line: 489,
            column: 63
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 489,
            column: 4
          },
          end: {
            line: 489,
            column: 63
          }
        }, {
          start: {
            line: 489,
            column: 4
          },
          end: {
            line: 489,
            column: 63
          }
        }],
        line: 489
      },
      '65': {
        loc: {
          start: {
            line: 545,
            column: 4
          },
          end: {
            line: 550,
            column: 5
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 545,
            column: 4
          },
          end: {
            line: 550,
            column: 5
          }
        }, {
          start: {
            line: 545,
            column: 4
          },
          end: {
            line: 550,
            column: 5
          }
        }],
        line: 545
      },
      '66': {
        loc: {
          start: {
            line: 548,
            column: 6
          },
          end: {
            line: 548,
            column: 42
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 548,
            column: 6
          },
          end: {
            line: 548,
            column: 42
          }
        }, {
          start: {
            line: 548,
            column: 6
          },
          end: {
            line: 548,
            column: 42
          }
        }],
        line: 548
      },
      '67': {
        loc: {
          start: {
            line: 557,
            column: 11
          },
          end: {
            line: 557,
            column: 91
          }
        },
        type: 'cond-expr',
        locations: [{
          start: {
            line: 557,
            column: 30
          },
          end: {
            line: 557,
            column: 51
          }
        }, {
          start: {
            line: 557,
            column: 54
          },
          end: {
            line: 557,
            column: 91
          }
        }],
        line: 557
      },
      '68': {
        loc: {
          start: {
            line: 569,
            column: 4
          },
          end: {
            line: 569,
            column: 46
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 569,
            column: 4
          },
          end: {
            line: 569,
            column: 46
          }
        }, {
          start: {
            line: 569,
            column: 4
          },
          end: {
            line: 569,
            column: 46
          }
        }],
        line: 569
      },
      '69': {
        loc: {
          start: {
            line: 569,
            column: 8
          },
          end: {
            line: 569,
            column: 38
          }
        },
        type: 'binary-expr',
        locations: [{
          start: {
            line: 569,
            column: 8
          },
          end: {
            line: 569,
            column: 16
          }
        }, {
          start: {
            line: 569,
            column: 20
          },
          end: {
            line: 569,
            column: 38
          }
        }],
        line: 569
      },
      '70': {
        loc: {
          start: {
            line: 570,
            column: 14
          },
          end: {
            line: 577,
            column: 5
          }
        },
        type: 'binary-expr',
        locations: [{
          start: {
            line: 570,
            column: 14
          },
          end: {
            line: 570,
            column: 21
          }
        }, {
          start: {
            line: 570,
            column: 25
          },
          end: {
            line: 577,
            column: 5
          }
        }],
        line: 570
      },
      '71': {
        loc: {
          start: {
            line: 573,
            column: 11
          },
          end: {
            line: 573,
            column: 111
          }
        },
        type: 'cond-expr',
        locations: [{
          start: {
            line: 573,
            column: 45
          },
          end: {
            line: 573,
            column: 99
          }
        }, {
          start: {
            line: 573,
            column: 102
          },
          end: {
            line: 573,
            column: 111
          }
        }],
        line: 573
      },
      '72': {
        loc: {
          start: {
            line: 593,
            column: 15
          },
          end: {
            line: 593,
            column: 34
          }
        },
        type: 'default-arg',
        locations: [{
          start: {
            line: 593,
            column: 21
          },
          end: {
            line: 593,
            column: 34
          }
        }],
        line: 593
      },
      '73': {
        loc: {
          start: {
            line: 598,
            column: 22
          },
          end: {
            line: 598,
            column: 49
          }
        },
        type: 'binary-expr',
        locations: [{
          start: {
            line: 598,
            column: 22
          },
          end: {
            line: 598,
            column: 41
          }
        }, {
          start: {
            line: 598,
            column: 45
          },
          end: {
            line: 598,
            column: 49
          }
        }],
        line: 598
      },
      '74': {
        loc: {
          start: {
            line: 622,
            column: 2
          },
          end: {
            line: 628,
            column: 3
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 622,
            column: 2
          },
          end: {
            line: 628,
            column: 3
          }
        }, {
          start: {
            line: 622,
            column: 2
          },
          end: {
            line: 628,
            column: 3
          }
        }],
        line: 622
      },
      '75': {
        loc: {
          start: {
            line: 642,
            column: 4
          },
          end: {
            line: 652,
            column: 5
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 642,
            column: 4
          },
          end: {
            line: 652,
            column: 5
          }
        }, {
          start: {
            line: 642,
            column: 4
          },
          end: {
            line: 652,
            column: 5
          }
        }],
        line: 642
      },
      '76': {
        loc: {
          start: {
            line: 664,
            column: 24
          },
          end: {
            line: 664,
            column: 72
          }
        },
        type: 'binary-expr',
        locations: [{
          start: {
            line: 664,
            column: 24
          },
          end: {
            line: 664,
            column: 51
          }
        }, {
          start: {
            line: 664,
            column: 55
          },
          end: {
            line: 664,
            column: 72
          }
        }],
        line: 664
      },
      '77': {
        loc: {
          start: {
            line: 665,
            column: 19
          },
          end: {
            line: 665,
            column: 138
          }
        },
        type: 'cond-expr',
        locations: [{
          start: {
            line: 665,
            column: 34
          },
          end: {
            line: 665,
            column: 115
          }
        }, {
          start: {
            line: 665,
            column: 118
          },
          end: {
            line: 665,
            column: 138
          }
        }],
        line: 665
      }
    },
    s: {
      '0': 0,
      '1': 0,
      '2': 0,
      '3': 0,
      '4': 0,
      '5': 0,
      '6': 0,
      '7': 0,
      '8': 0,
      '9': 0,
      '10': 0,
      '11': 0,
      '12': 0,
      '13': 0,
      '14': 0,
      '15': 0,
      '16': 0,
      '17': 0,
      '18': 0,
      '19': 0,
      '20': 0,
      '21': 0,
      '22': 0,
      '23': 0,
      '24': 0,
      '25': 0,
      '26': 0,
      '27': 0,
      '28': 0,
      '29': 0,
      '30': 0,
      '31': 0,
      '32': 0,
      '33': 0,
      '34': 0,
      '35': 0,
      '36': 0,
      '37': 0,
      '38': 0,
      '39': 0,
      '40': 0,
      '41': 0,
      '42': 0,
      '43': 0,
      '44': 0,
      '45': 0,
      '46': 0,
      '47': 0,
      '48': 0,
      '49': 0,
      '50': 0,
      '51': 0,
      '52': 0,
      '53': 0,
      '54': 0,
      '55': 0,
      '56': 0,
      '57': 0,
      '58': 0,
      '59': 0,
      '60': 0,
      '61': 0,
      '62': 0,
      '63': 0,
      '64': 0,
      '65': 0,
      '66': 0,
      '67': 0,
      '68': 0,
      '69': 0,
      '70': 0,
      '71': 0,
      '72': 0,
      '73': 0,
      '74': 0,
      '75': 0,
      '76': 0,
      '77': 0,
      '78': 0,
      '79': 0,
      '80': 0,
      '81': 0,
      '82': 0,
      '83': 0,
      '84': 0,
      '85': 0,
      '86': 0,
      '87': 0,
      '88': 0,
      '89': 0,
      '90': 0,
      '91': 0,
      '92': 0,
      '93': 0,
      '94': 0,
      '95': 0,
      '96': 0,
      '97': 0,
      '98': 0,
      '99': 0,
      '100': 0,
      '101': 0,
      '102': 0,
      '103': 0,
      '104': 0,
      '105': 0,
      '106': 0,
      '107': 0,
      '108': 0,
      '109': 0,
      '110': 0,
      '111': 0,
      '112': 0,
      '113': 0,
      '114': 0,
      '115': 0,
      '116': 0,
      '117': 0,
      '118': 0,
      '119': 0,
      '120': 0,
      '121': 0,
      '122': 0,
      '123': 0,
      '124': 0,
      '125': 0,
      '126': 0,
      '127': 0,
      '128': 0,
      '129': 0,
      '130': 0,
      '131': 0,
      '132': 0,
      '133': 0,
      '134': 0,
      '135': 0,
      '136': 0,
      '137': 0,
      '138': 0,
      '139': 0,
      '140': 0,
      '141': 0,
      '142': 0,
      '143': 0,
      '144': 0,
      '145': 0,
      '146': 0,
      '147': 0,
      '148': 0,
      '149': 0,
      '150': 0,
      '151': 0,
      '152': 0,
      '153': 0,
      '154': 0,
      '155': 0,
      '156': 0,
      '157': 0,
      '158': 0,
      '159': 0,
      '160': 0,
      '161': 0,
      '162': 0,
      '163': 0,
      '164': 0,
      '165': 0,
      '166': 0,
      '167': 0,
      '168': 0,
      '169': 0,
      '170': 0,
      '171': 0,
      '172': 0,
      '173': 0,
      '174': 0,
      '175': 0,
      '176': 0,
      '177': 0,
      '178': 0,
      '179': 0,
      '180': 0,
      '181': 0,
      '182': 0,
      '183': 0,
      '184': 0,
      '185': 0,
      '186': 0,
      '187': 0,
      '188': 0,
      '189': 0,
      '190': 0,
      '191': 0,
      '192': 0,
      '193': 0,
      '194': 0,
      '195': 0,
      '196': 0,
      '197': 0,
      '198': 0,
      '199': 0,
      '200': 0,
      '201': 0,
      '202': 0,
      '203': 0,
      '204': 0,
      '205': 0,
      '206': 0,
      '207': 0,
      '208': 0,
      '209': 0,
      '210': 0,
      '211': 0,
      '212': 0,
      '213': 0,
      '214': 0,
      '215': 0,
      '216': 0,
      '217': 0,
      '218': 0,
      '219': 0,
      '220': 0,
      '221': 0,
      '222': 0,
      '223': 0,
      '224': 0
    },
    f: {
      '0': 0,
      '1': 0,
      '2': 0,
      '3': 0,
      '4': 0,
      '5': 0,
      '6': 0,
      '7': 0,
      '8': 0,
      '9': 0,
      '10': 0,
      '11': 0,
      '12': 0,
      '13': 0,
      '14': 0,
      '15': 0,
      '16': 0,
      '17': 0,
      '18': 0,
      '19': 0,
      '20': 0,
      '21': 0,
      '22': 0,
      '23': 0,
      '24': 0,
      '25': 0,
      '26': 0,
      '27': 0,
      '28': 0,
      '29': 0,
      '30': 0,
      '31': 0,
      '32': 0,
      '33': 0,
      '34': 0,
      '35': 0,
      '36': 0,
      '37': 0,
      '38': 0,
      '39': 0,
      '40': 0,
      '41': 0,
      '42': 0,
      '43': 0,
      '44': 0,
      '45': 0,
      '46': 0,
      '47': 0,
      '48': 0,
      '49': 0,
      '50': 0,
      '51': 0,
      '52': 0,
      '53': 0,
      '54': 0,
      '55': 0,
      '56': 0,
      '57': 0,
      '58': 0,
      '59': 0,
      '60': 0,
      '61': 0,
      '62': 0,
      '63': 0,
      '64': 0,
      '65': 0,
      '66': 0,
      '67': 0,
      '68': 0,
      '69': 0,
      '70': 0,
      '71': 0,
      '72': 0,
      '73': 0,
      '74': 0,
      '75': 0,
      '76': 0,
      '77': 0
    },
    b: {
      '0': [0],
      '1': [0, 0],
      '2': [0, 0],
      '3': [0, 0],
      '4': [0, 0],
      '5': [0, 0],
      '6': [0, 0],
      '7': [0, 0],
      '8': [0, 0],
      '9': [0, 0],
      '10': [0, 0],
      '11': [0, 0],
      '12': [0, 0],
      '13': [0, 0],
      '14': [0, 0],
      '15': [0, 0],
      '16': [0, 0],
      '17': [0, 0],
      '18': [0, 0],
      '19': [0, 0],
      '20': [0, 0],
      '21': [0, 0],
      '22': [0, 0],
      '23': [0, 0],
      '24': [0, 0],
      '25': [0, 0],
      '26': [0, 0],
      '27': [0, 0],
      '28': [0, 0],
      '29': [0, 0],
      '30': [0, 0],
      '31': [0],
      '32': [0, 0],
      '33': [0, 0],
      '34': [0, 0],
      '35': [0, 0],
      '36': [0, 0],
      '37': [0],
      '38': [0, 0],
      '39': [0, 0],
      '40': [0, 0],
      '41': [0, 0],
      '42': [0],
      '43': [0, 0],
      '44': [0, 0],
      '45': [0, 0],
      '46': [0],
      '47': [0, 0],
      '48': [0],
      '49': [0, 0],
      '50': [0],
      '51': [0],
      '52': [0, 0],
      '53': [0, 0],
      '54': [0, 0],
      '55': [0],
      '56': [0],
      '57': [0, 0],
      '58': [0, 0, 0, 0],
      '59': [0, 0],
      '60': [0, 0],
      '61': [0, 0],
      '62': [0, 0],
      '63': [0, 0],
      '64': [0, 0],
      '65': [0, 0],
      '66': [0, 0],
      '67': [0, 0],
      '68': [0, 0],
      '69': [0, 0],
      '70': [0, 0],
      '71': [0, 0],
      '72': [0],
      '73': [0, 0],
      '74': [0, 0],
      '75': [0, 0],
      '76': [0, 0],
      '77': [0, 0]
    },
    _coverageSchema: '332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'
  },
      coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  coverageData.hash = hash;
  return coverage[path] = coverageData;
}();

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _stringify = require('babel-runtime/core-js/json/stringify');

var _stringify2 = _interopRequireDefault(_stringify);

var _typeof2 = require('babel-runtime/helpers/typeof');

var _typeof3 = _interopRequireDefault(_typeof2);

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _promise = require('babel-runtime/core-js/promise');

var _promise2 = _interopRequireDefault(_promise);

var _assign = require('babel-runtime/core-js/object/assign');

var _assign2 = _interopRequireDefault(_assign);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _uportCredentials = require('uport-credentials');

var _didJwt = require('did-jwt');

var _mobileDetect = require('mobile-detect');

var _mobileDetect2 = _interopRequireDefault(_mobileDetect);

var _mnid = require('mnid');

var _uportTransports = require('uport-transports');

var _pubsubJs = require('pubsub-js');

var _pubsubJs2 = _interopRequireDefault(_pubsubJs);

var _store = require('store');

var _store2 = _interopRequireDefault(_store);

var _uportLite = require('uport-lite');

var _uportLite2 = _interopRequireDefault(_uportLite);

var _util = require('./util');

var _UportSubprovider = require('./UportSubprovider');

var _UportSubprovider2 = _interopRequireDefault(_UportSubprovider);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Connect = function () {
  /**
   * Instantiates a new uPort Connect object.
   *
   * @example
   * import  Connect  from 'uport-connect'
   * const connect = new Connect('MydappName')
   *
   * @param    {String}      appName                      The name of your app
   * @param    {Object}      [opts]                       optional parameters
   * @param    {String}      [opts.description]           A short description of your app that can be displayed to users when making requests
   * @param    {String}      [opts.profileImage]          A URL for an image to be displayed as the avatar for this app in requests
   * @param    {String}      [opts.bannerImage]           A URL for an image to be displayed as the banner for this app in requests
   * @param    {String}      [opts.brandColor]            A HEX brand color to be be displayed where branding is required '#000000'
   * @param    {Object}      [opts.network='rinkeby']     network config object or string name, ie. { id: '0x1', rpcUrl: 'https://mainnet.infura.io' } or 'kovan', 'mainnet', 'ropsten', 'rinkeby'.
   * @param    {String}      [opts.accountType]           Ethereum account type: "general", "segregated", "keypair", or "none"
   * @param    {Boolean}     [opts.isMobile]              Configured by default by detecting client, but can optionally pass boolean to indicate whether this is instantiated on a mobile client
   * @param    {Boolean}     [opts.useStore=true]         When true, object state will be written to local storage on each state change
   * @param    {Object}      [opts.store]                 Storage inteferface with synchronous get() => statObj and set(stateObj) functions, by default store is local storage. For asynchronous storage, set useStore false and handle manually.
   * @param    {Boolean}     [opts.usePush=true]          Use the pushTransport when a pushToken is available. Set to false to force connect to use standard transport
   * @param    {String[]}    [opts.vc]                    An array of verified claims describing this identity
   * @param    {Function}    [opts.transport]             Optional custom transport for desktop, non-push requests
   * @param    {Function}    [opts.mobileTransport]       Optional custom transport for mobile requests
   * @param    {Function}    [opts.mobileUriHandler]      Optional uri handler for mobile requests, if using default transports
   * @param    {Object}      [opts.muportConfig]          Configuration object for muport did resolver. See [muport-did-resolver](https://github.com/uport-project/muport-did-resolver)
   * @param    {Object}      [opts.ethrConfig]            Configuration object for ethr did resolver. See [ethr-did-resolver](https://github.com/uport-project/ethr-did-resolver)
   * @param    {Object}      [opts.registry]              Configuration for uPort DID Resolver (DEPRECATED) See [uport-did-resolver](https://github.com/uport-project/uport-did-resolver)
   * @return   {Connect}                                  self
   */
  function Connect(appName) {
    var _this = this;

    var opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : (cov_1ytb5bt5lt.b[0][0]++, {});
    (0, _classCallCheck3.default)(this, Connect);
    cov_1ytb5bt5lt.f[0]++;
    cov_1ytb5bt5lt.s[0]++;

    // Config
    this.appName = (cov_1ytb5bt5lt.b[1][0]++, appName) || (cov_1ytb5bt5lt.b[1][1]++, 'uport-connect-app');
    cov_1ytb5bt5lt.s[1]++;
    this.description = opts.description;
    cov_1ytb5bt5lt.s[2]++;
    this.profileImage = opts.profileImage;
    cov_1ytb5bt5lt.s[3]++;
    this.bannerImage = opts.bannerImage;
    cov_1ytb5bt5lt.s[4]++;
    this.brandColor = opts.brandColor;
    cov_1ytb5bt5lt.s[5]++;
    this.network = _uportTransports.network.config.network(opts.network);
    cov_1ytb5bt5lt.s[6]++;
    this.accountType = opts.accountType === 'none' ? (cov_1ytb5bt5lt.b[2][0]++, undefined) : (cov_1ytb5bt5lt.b[2][1]++, opts.accountType);
    cov_1ytb5bt5lt.s[7]++;
    this.isOnMobile = opts.isMobile === undefined ? (cov_1ytb5bt5lt.b[3][0]++, (0, _util.isMobile)()) : (cov_1ytb5bt5lt.b[3][1]++, opts.isMobile);
    cov_1ytb5bt5lt.s[8]++;
    this.useStore = opts.useStore === undefined ? (cov_1ytb5bt5lt.b[4][0]++, true) : (cov_1ytb5bt5lt.b[4][1]++, opts.useStore);
    cov_1ytb5bt5lt.s[9]++;
    this.usePush = opts.usePush === undefined ? (cov_1ytb5bt5lt.b[5][0]++, true) : (cov_1ytb5bt5lt.b[5][1]++, opts.usePush);
    cov_1ytb5bt5lt.s[10]++;
    this.vc = Array.isArray(opts.vc) ? (cov_1ytb5bt5lt.b[6][0]++, opts.vc) : (cov_1ytb5bt5lt.b[6][1]++, []);

    // Disallow segregated account on mainnet
    cov_1ytb5bt5lt.s[11]++;
    if ((cov_1ytb5bt5lt.b[8][0]++, this.network === _uportTransports.network.defaults.networks.mainnet) && (cov_1ytb5bt5lt.b[8][1]++, this.accountType === 'segregated')) {
      cov_1ytb5bt5lt.b[7][0]++;
      cov_1ytb5bt5lt.s[12]++;

      throw new Error('Segregated accounts are not supported on mainnet');
    } else {
      cov_1ytb5bt5lt.b[7][1]++;
    }

    // Storage
    cov_1ytb5bt5lt.s[13]++;
    this.store = (cov_1ytb5bt5lt.b[9][0]++, opts.store) || (cov_1ytb5bt5lt.b[9][1]++, new LocalStorageStore());

    // Initialize private state
    cov_1ytb5bt5lt.s[14]++;
    this._state = {};

    // Load any existing state if any
    cov_1ytb5bt5lt.s[15]++;
    if (this.useStore) {
        cov_1ytb5bt5lt.b[10][0]++;
        cov_1ytb5bt5lt.s[16]++;
        this.loadState();
      } else {
      cov_1ytb5bt5lt.b[10][1]++;
    }cov_1ytb5bt5lt.s[17]++;
    if (!this.keypair.did) {
        cov_1ytb5bt5lt.b[11][0]++;
        cov_1ytb5bt5lt.s[18]++;
        this.keypair = _uportCredentials.Credentials.createIdentity();
      } else {
      cov_1ytb5bt5lt.b[11][1]++;
    } // Transports
    cov_1ytb5bt5lt.s[19]++;
    this.PubSub = _pubsubJs2.default;
    cov_1ytb5bt5lt.s[20]++;
    this.transport = (cov_1ytb5bt5lt.b[12][0]++, opts.transport) || (cov_1ytb5bt5lt.b[12][1]++, connectTransport(appName));
    cov_1ytb5bt5lt.s[21]++;
    this.useDeeplinks = true;
    cov_1ytb5bt5lt.s[22]++;
    this.mobileTransport = (cov_1ytb5bt5lt.b[13][0]++, opts.mobileTransport) || (cov_1ytb5bt5lt.b[13][1]++, _uportTransports.transport.url.send({
      uriHandler: opts.mobileUriHandler,
      messageToURI: function messageToURI(m) {
        cov_1ytb5bt5lt.f[1]++;
        cov_1ytb5bt5lt.s[23]++;
        return _this.useDeeplinks ? (cov_1ytb5bt5lt.b[14][0]++, _uportTransports.message.util.messageToDeeplinkURI(m)) : (cov_1ytb5bt5lt.b[14][1]++, _uportTransports.message.util.messageToUniversalURI(m));
      }
    }));
    cov_1ytb5bt5lt.s[24]++;
    this.onloadResponse = (cov_1ytb5bt5lt.b[15][0]++, opts.onloadResponse) || (cov_1ytb5bt5lt.b[15][1]++, _uportTransports.transport.url.getResponse());
    cov_1ytb5bt5lt.s[25]++;
    this.pushTransport = (cov_1ytb5bt5lt.b[17][0]++, this.pushToken) && (cov_1ytb5bt5lt.b[17][1]++, this.publicEncKey) ? (cov_1ytb5bt5lt.b[16][0]++, pushTransport(this.pushToken, this.publicEncKey)) : (cov_1ytb5bt5lt.b[16][1]++, undefined);
    cov_1ytb5bt5lt.s[26]++;
    _uportTransports.transport.url.listenResponse(function (err, res) {
      cov_1ytb5bt5lt.f[2]++;
      cov_1ytb5bt5lt.s[27]++;

      if (err) {
          cov_1ytb5bt5lt.b[18][0]++;
          cov_1ytb5bt5lt.s[28]++;
          throw err;
        } else {
        cov_1ytb5bt5lt.b[18][1]++;
      } // Switch to deep links after first universal link success
      cov_1ytb5bt5lt.s[29]++;
      _this.useDeeplinks = true;
      cov_1ytb5bt5lt.s[30]++;
      _this.pubResponse(res);
    });

    // Credential (uport-js) config for verification
    cov_1ytb5bt5lt.s[31]++;
    this.registry = (cov_1ytb5bt5lt.b[19][0]++, opts.registry) || (cov_1ytb5bt5lt.b[19][1]++, (0, _uportLite2.default)({ networks: _uportTransports.network.config.networkToNetworkSet(this.network) }));
    cov_1ytb5bt5lt.s[32]++;
    this.resolverConfigs = { registry: this.registry, ethrConfig: opts.ethrConfig, muportConfig: opts.muportConfig };
    cov_1ytb5bt5lt.s[33]++;
    this.credentials = new _uportCredentials.Credentials((0, _assign2.default)(this.keypair, this.resolverConfigs)); // TODO can resolver configs not be passed through
  }

  /**
   *  Instantiates and returns a web3 styple provider wrapped with uPort functionality.
   *  For more details see uportSubprovider. uPort overrides eth_coinbase and eth_accounts
   *  to start a get address flow or to return an already received address. It also
   *  overrides eth_sendTransaction to start the send transaction flow to pass the
   *  transaction to the uPort app.
   *
   *  @example
   *  const uportProvider = connect.getProvider()
   *  const web3 = new Web3(uportProvider)
   *
   *  @param      {Object}           [provider]    An optional web3 style provider to wrap, default is a http provider, non standard provider may cause unexpected behavior, using default is suggested.
   *  @return     {UportSubprovider}               A web3 style provider wrapped with uPort functionality
   */


  (0, _createClass3.default)(Connect, [{
    key: 'getProvider',
    value: function getProvider(provider) {
      var _this2 = this;

      cov_1ytb5bt5lt.f[3]++;

      var subProvider = (cov_1ytb5bt5lt.s[34]++, new _UportSubprovider2.default({
        requestAddress: function requestAddress() {
          cov_1ytb5bt5lt.f[4]++;

          var requestID = (cov_1ytb5bt5lt.s[35]++, 'addressReqProvider');
          cov_1ytb5bt5lt.s[36]++;
          _this2.requestDisclosure({ accountType: (cov_1ytb5bt5lt.b[20][0]++, _this2.accountType) || (cov_1ytb5bt5lt.b[20][1]++, 'keypair') }, requestID);
          cov_1ytb5bt5lt.s[37]++;
          return _this2.onResponse(requestID).then(function (res) {
            cov_1ytb5bt5lt.f[5]++;
            cov_1ytb5bt5lt.s[38]++;
            return res.payload.address;
          });
        },
        sendTransaction: function sendTransaction(txObj) {
          cov_1ytb5bt5lt.f[6]++;
          cov_1ytb5bt5lt.s[39]++;

          delete txObj['from'];
          var requestID = (cov_1ytb5bt5lt.s[40]++, 'txReqProvider');
          cov_1ytb5bt5lt.s[41]++;
          _this2.sendTransaction(txObj, requestID);
          cov_1ytb5bt5lt.s[42]++;
          return _this2.onResponse(requestID).then(function (res) {
            cov_1ytb5bt5lt.f[7]++;
            cov_1ytb5bt5lt.s[43]++;
            return res.payload;
          });
        },
        signTypedData: function signTypedData(typedData) {
          cov_1ytb5bt5lt.f[8]++;

          var requestID = (cov_1ytb5bt5lt.s[44]++, 'typedDataSigReqProvider');
          cov_1ytb5bt5lt.s[45]++;
          _this2.requestTypedDataSignature(typedData, requestID);
          cov_1ytb5bt5lt.s[46]++;
          return _this2.onResponse(requestID).then(function (res) {
            cov_1ytb5bt5lt.f[9]++;
            cov_1ytb5bt5lt.s[47]++;
            return res.payload;
          });
        },
        personalSign: function personalSign(data) {
          cov_1ytb5bt5lt.f[10]++;

          var requestID = (cov_1ytb5bt5lt.s[48]++, 'personalSignReqProvider');
          cov_1ytb5bt5lt.s[49]++;
          _this2.requestPersonalSign(data, requestID);
          cov_1ytb5bt5lt.s[50]++;
          return _this2.onResponse(requestID).then(function (res) {
            cov_1ytb5bt5lt.f[11]++;
            cov_1ytb5bt5lt.s[51]++;
            return res.payload;
          });
        },
        provider: provider, network: this.network
      }));
      cov_1ytb5bt5lt.s[52]++;
      if (this.address) {
          cov_1ytb5bt5lt.b[21][0]++;
          cov_1ytb5bt5lt.s[53]++;
          subProvider.setAccount(this.address);
        } else {
        cov_1ytb5bt5lt.b[21][1]++;
      }cov_1ytb5bt5lt.s[54]++;
      return subProvider;
    }

    /**
     *  Get response by id of earlier request, returns promise which resolves when first
     *  reponse with given id is available. If looking for multiple responses of same id,
     *  listen instead by passing a callback.
     *
     *  @param    {String}       id          id of request you are waiting for a response for
     *  @param    {Function}     cb          an optional callback function, which is called each time a valid repsonse for a given id is available vs having a single promise returned
     *  @return   {Promise<Object, Error>}   promise resolves once valid response for given id is avaiable, otherwise rejects with error, no promised returned if callback given
     */

  }, {
    key: 'onResponse',
    value: function onResponse(id, cb) {
      var _this3 = this;

      cov_1ytb5bt5lt.f[12]++;
      cov_1ytb5bt5lt.s[55]++;

      var parseResponse = function parseResponse(res) {
        cov_1ytb5bt5lt.f[13]++;
        cov_1ytb5bt5lt.s[56]++;

        if (res.error) {
            cov_1ytb5bt5lt.b[22][0]++;
            cov_1ytb5bt5lt.s[57]++;
            return _promise2.default.reject((0, _assign2.default)({ id: id }, res));
          } else {
          cov_1ytb5bt5lt.b[22][1]++;
        }cov_1ytb5bt5lt.s[58]++;
        if (_uportTransports.message.util.isJWT(res.payload)) {
          cov_1ytb5bt5lt.b[23][0]++;

          var jwt = (cov_1ytb5bt5lt.s[59]++, res.payload);
          var decoded = (cov_1ytb5bt5lt.s[60]++, (0, _didJwt.decodeJWT)(jwt));
          cov_1ytb5bt5lt.s[61]++;
          if (decoded.payload.claim) {
            cov_1ytb5bt5lt.b[24][0]++;
            cov_1ytb5bt5lt.s[62]++;

            return _promise2.default.resolve((0, _assign2.default)({ id: id }, res));
          } else {
            cov_1ytb5bt5lt.b[24][1]++;
          }
          cov_1ytb5bt5lt.s[63]++;
          return _this3.verifyResponse(jwt).then(function (parsedRes) {
            cov_1ytb5bt5lt.f[14]++;
            cov_1ytb5bt5lt.s[64]++;

            // Set identifiers present in the response
            // TODO maybe just change name in uport-js
            if (parsedRes.boxPub) {
                cov_1ytb5bt5lt.b[25][0]++;
                cov_1ytb5bt5lt.s[65]++;
                parsedRes.publicEncKey = parsedRes.boxPub;
              } else {
              cov_1ytb5bt5lt.b[25][1]++;
            }cov_1ytb5bt5lt.s[66]++;
            _this3.setState(parsedRes);
            cov_1ytb5bt5lt.s[67]++;
            return { id: id, payload: parsedRes, data: res.data };
          });
        } else {
          cov_1ytb5bt5lt.b[23][1]++;
          cov_1ytb5bt5lt.s[68]++;

          return _promise2.default.resolve((0, _assign2.default)({ id: id }, res));
        }
      };

      cov_1ytb5bt5lt.s[69]++;
      if ((cov_1ytb5bt5lt.b[27][0]++, this.onloadResponse) && (cov_1ytb5bt5lt.b[27][1]++, this.onloadResponse.id === id)) {
        cov_1ytb5bt5lt.b[26][0]++;

        var onloadResponse = (cov_1ytb5bt5lt.s[70]++, this.onloadResponse);
        cov_1ytb5bt5lt.s[71]++;
        this.onloadResponse = null;
        cov_1ytb5bt5lt.s[72]++;
        return parseResponse(onloadResponse);
      } else {
        cov_1ytb5bt5lt.b[26][1]++;
      }

      cov_1ytb5bt5lt.s[73]++;
      if (cb) {
        cov_1ytb5bt5lt.b[28][0]++;
        cov_1ytb5bt5lt.s[74]++;

        this.PubSub.subscribe(id, function (msg, res) {
          cov_1ytb5bt5lt.f[15]++;
          cov_1ytb5bt5lt.s[75]++;

          parseResponse(res).then(function (res) {
            cov_1ytb5bt5lt.f[16]++;
            cov_1ytb5bt5lt.s[76]++;
            cb(null, res);
          }, function (err) {
            cov_1ytb5bt5lt.f[17]++;
            cov_1ytb5bt5lt.s[77]++;
            cb(err, null);
          });
        });
      } else {
        cov_1ytb5bt5lt.b[28][1]++;
        cov_1ytb5bt5lt.s[78]++;

        return new _promise2.default(function (resolve, reject) {
          cov_1ytb5bt5lt.f[18]++;
          cov_1ytb5bt5lt.s[79]++;

          _this3.PubSub.subscribe(id, function (msg, res) {
            cov_1ytb5bt5lt.f[19]++;
            cov_1ytb5bt5lt.s[80]++;

            _this3.PubSub.unsubscribe(id);
            cov_1ytb5bt5lt.s[81]++;
            parseResponse(res).then(resolve, reject);
          });
        });
      }
    }

    /**
     * Push a response payload to uPort connect to be handled. Useful if implementing your own transports
     * and you are getting responses with your own functions, listeners, event handlers etc. It will
     * parse the response and resolve it to any listening onResponse functions with the matching id. A
     * response object in connect is of the form {id, payload, data}, where payload and id required. Payload is the
     * response payload (url or JWT) from a uPort client.
     *
     * @param {Object} response  a wrapped response payload, of form {id, res, data}, res and id required
     */

  }, {
    key: 'pubResponse',
    value: function pubResponse(response) {
      cov_1ytb5bt5lt.f[20]++;
      cov_1ytb5bt5lt.s[82]++;

      if ((cov_1ytb5bt5lt.b[30][0]++, !response) || (cov_1ytb5bt5lt.b[30][1]++, !response.id)) {
          cov_1ytb5bt5lt.b[29][0]++;
          cov_1ytb5bt5lt.s[83]++;
          throw new Error('Response payload requires an id');
        } else {
        cov_1ytb5bt5lt.b[29][1]++;
      }cov_1ytb5bt5lt.s[84]++;
      this.PubSub.publish(response.id, { payload: response.payload, data: response.data });
    }

    /**
     * @private
     * Verify a jwt and save the resulting doc to this instance, then process the
     * disclosure payload with this.credentials
     * @param {JWT} token   the JWT to be verified
     */

  }, {
    key: 'verifyResponse',
    value: function verifyResponse(token) {
      var _this4 = this;

      cov_1ytb5bt5lt.f[21]++;
      cov_1ytb5bt5lt.s[85]++;

      return (0, _didJwt.verifyJWT)(token, { audience: this.credentials.did }).then(function (res) {
        cov_1ytb5bt5lt.f[22]++;
        cov_1ytb5bt5lt.s[86]++;

        _this4.doc = res.doc;
        cov_1ytb5bt5lt.s[87]++;
        return _this4.credentials.processDisclosurePayload(res);
      });
    }

    /**
     *  Send a request message to a uPort client. Useful function if you want to pass additional transport options and/or send a request you already created elsewhere.
     *
     *  @param    {String}     request           a request message to send to a uPort client
     *  @param    {String}     id                id of the request, which you will later use to handle the response
     *  @param    {Object}     [opts]            optional parameters for a callback, see (specs for more details)[https://github.com/uport-project/specs/blob/develop/messages/index.md]
     *  @param    {String}     opts.redirectUrl  If on mobile client, the url you want the uPort client to return control to once it completes it's flow. Depending on the params below, this redirect can include the response or it may be returned to the callback in the request token.
     *  @param    {String}     opts.data         A string of any data you want later returned with the response. It may be contextual to the original request. (i.e. a request id from your server)
     *  @param    {String}     opts.type         Type specifies the callback action. 'post' to send response to callback in request token or 'redirect' to send response in redirect url.
     *  @param    {Function}   opts.cancel       When using the default QR send, but handling the response yourself, this function will be called when a user closes the request modal.
     */

  }, {
    key: 'send',
    value: function send(request, id) {
      var _this5 = this;

      var _ref = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : (cov_1ytb5bt5lt.b[31][0]++, {}),
          redirectUrl = _ref.redirectUrl,
          data = _ref.data,
          type = _ref.type,
          cancel = _ref.cancel;

      cov_1ytb5bt5lt.f[23]++;
      cov_1ytb5bt5lt.s[88]++;

      if (!id) {
          cov_1ytb5bt5lt.b[32][0]++;
          cov_1ytb5bt5lt.s[89]++;
          throw new Error('Requires request id');
        } else {
        cov_1ytb5bt5lt.b[32][1]++;
      }cov_1ytb5bt5lt.s[90]++;
      if (this.isOnMobile) {
        cov_1ytb5bt5lt.b[33][0]++;
        cov_1ytb5bt5lt.s[91]++;

        if (!redirectUrl & !type) {
            cov_1ytb5bt5lt.b[34][0]++;
            cov_1ytb5bt5lt.s[92]++;
            type = 'redirect';
          } else {
          cov_1ytb5bt5lt.b[34][1]++;
        }cov_1ytb5bt5lt.s[93]++;
        this.mobileTransport(request, { id: id, data: data, redirectUrl: redirectUrl, type: type });
      } else {
          cov_1ytb5bt5lt.b[33][1]++;
          cov_1ytb5bt5lt.s[94]++;
          if ((cov_1ytb5bt5lt.b[36][0]++, this.usePush) && (cov_1ytb5bt5lt.b[36][1]++, this.pushTransport)) {
            cov_1ytb5bt5lt.b[35][0]++;
            cov_1ytb5bt5lt.s[95]++;

            this.pushTransport(request, { data: data }).then(function (res) {
              cov_1ytb5bt5lt.f[24]++;
              cov_1ytb5bt5lt.s[96]++;
              return _this5.PubSub.publish(id, res);
            });
          } else {
            cov_1ytb5bt5lt.b[35][1]++;
            cov_1ytb5bt5lt.s[97]++;

            this.transport(request, { data: data, cancel: cancel }).then(function (res) {
              cov_1ytb5bt5lt.f[25]++;
              cov_1ytb5bt5lt.s[98]++;
              return _this5.PubSub.publish(id, res);
            });
          }
        }
    }

    /**
     *  Builds and returns a contract object which can be used to interact with
     *  a given contract. Similar to web3.eth.contract. Once specifying .at(address)
     *  you can call the contract functions with this object. It will create a transaction
     *  sign request and send it. Functionality limited to function calls which require sending
     *  a transaction, as these are the only calls which require interaction with a uPort client.
     *  For reading and/or events use web3 alongside or a similar library.
     *
     * @example
     * const abi = [{"constant":false,"inputs":[{"name":"status","type":"string"}],"name":"updateStatus","outputs":[],"payable":false,"type":"function"},{"constant":false,"inputs":[{"name":"addr","type":"address"}],"name":"getStatus","outputs":[{"name":"","type":"string"}],"payable":false,"type":"function"}]
     * const StatusContract = connect.contract(abi).at('0x70A804cCE17149deB6030039798701a38667ca3B')
     * const reqId = 'updateStatus'
     * StatusContract.updateStatus('helloStatus', reqId)
     *  connect.onResponse('reqId').then(res => {
     *    const txHash = res.payload
     *  })
     *
     *  @param    {Object}       abi      contract ABI
     *  @return   {Object}                contract object
     */

  }, {
    key: 'contract',
    value: function contract(abi) {
      var _this6 = this;

      cov_1ytb5bt5lt.f[26]++;
      cov_1ytb5bt5lt.s[99]++;

      var txObjHandler = function txObjHandler(txObj, id, sendOpts) {
        cov_1ytb5bt5lt.f[27]++;
        cov_1ytb5bt5lt.s[100]++;

        txObj.fn = txObj.function;
        cov_1ytb5bt5lt.s[101]++;
        delete txObj['function'];
        cov_1ytb5bt5lt.s[102]++;
        return _this6.sendTransaction(txObj, id, sendOpts);
      };
      cov_1ytb5bt5lt.s[103]++;
      return (0, _uportCredentials.ContractFactory)(txObjHandler.bind(this))(abi);
    }

    /**
     *  Given a transaction object (similarly defined as the web3 transaction object)
     *  it creates a transaction request and sends it. A transaction hash is later
     *  returned as the response if the user selected to sign it.
     *
     *  @example
     *  const txobject = {
     *    to: '0xc3245e75d3ecd1e81a9bfb6558b6dafe71e9f347',
     *    value: '0.1',
     *    fn: "setStatus(string 'hello', bytes32 '0xc3245e75d3ecd1e81a9bfb6558b6dafe71e9f347')",
     *    appName: 'MyDapp'
     *  }
     *  connect.sendTransaction(txobject, 'setStatus')
     *  connect.onResponse('setStatus').then(res => {
     *    const txHash = res.payload
     *  })
     *
     *  @param    {Object}    txObj
     *  @param    {String}    [id='txReq']    string to identify request, later used to get response, name of function call is used by default, if not a function call, the default is 'txReq'
     *  @param    {Object}    [sendOpts]      reference send function options
     */

  }, {
    key: 'sendTransaction',
    value: function () {
      var _ref2 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee() {
        var txObj = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (cov_1ytb5bt5lt.b[37][0]++, {});

        var _this7 = this;

        var id = arguments[1];
        var sendOpts = arguments[2];
        return _regenerator2.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                cov_1ytb5bt5lt.f[28]++;
                cov_1ytb5bt5lt.s[104]++;

                if (txObj.vc) {
                  _context.next = 9;
                  break;
                }

                cov_1ytb5bt5lt.b[38][0]++;
                cov_1ytb5bt5lt.s[105]++;
                _context.next = 7;
                return this.signAndUploadProfile();

              case 7:
                _context.next = 10;
                break;

              case 9:
                cov_1ytb5bt5lt.b[38][1]++;

              case 10:
                cov_1ytb5bt5lt.s[106]++;

                txObj = (0, _extends3.default)({
                  vc: this.vc }, txObj, {
                  to: (0, _mnid.isMNID)(txObj.to) ? (cov_1ytb5bt5lt.b[39][0]++, txObj.to) : (cov_1ytb5bt5lt.b[39][1]++, (0, _mnid.encode)({ network: this.network.id, address: txObj.to })),
                  rpcUrl: this.network.rpcUrl

                  //  Create default id, where id is function name, or txReq if no function name
                });cov_1ytb5bt5lt.s[107]++;
                if (!id) {
                    cov_1ytb5bt5lt.b[40][0]++;
                    cov_1ytb5bt5lt.s[108]++;
                    id = txObj.fn ? (cov_1ytb5bt5lt.b[41][0]++, txObj.fn.split('(')[0]) : (cov_1ytb5bt5lt.b[41][1]++, 'txReq');
                  } else {
                  cov_1ytb5bt5lt.b[40][1]++;
                }cov_1ytb5bt5lt.s[109]++;
                this.credentials.createTxRequest(txObj, { callbackUrl: this.genCallback(id) }).then(function (jwt) {
                  cov_1ytb5bt5lt.f[29]++;
                  cov_1ytb5bt5lt.s[110]++;
                  return _this7.send(jwt, id, sendOpts);
                });

              case 16:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function sendTransaction() {
        return _ref2.apply(this, arguments);
      }

      return sendTransaction;
    }()

    /**
     *  Creates and sends a request for a user to [sign a verification](https://github.com/uport-project/specs/blob/develop/messages/verificationreq.md) and sends the request to the uPort user.
     *
     *  @example
     *  const unsignedClaim = {
     *    claim: {
     *      "Citizen of city X": {
     *        "Allowed to vote": true,
     *        "Document": "QmZZBBKPS2NWc6PMZbUk9zUHCo1SHKzQPPX4ndfwaYzmPW"
     *      }
     *    },
     *    sub: "did:ethr:0x413daa771a2fc9c5ae5a66abd144881ef2498c54"
     *  }
     *  connect.requestVerificationSignature(unsignedClaim).then(jwt => {
     *    ...
     *  })
     *
     *  @param    {Object}     unsignedClaim          unsigned claim object which you want the user to attest
     *  @param    {String}     sub                    the DID which the unsigned claim is about
     *  @param    {String}     [id='signVerReq']      string to identify request, later used to get response
     *  @param    {Object}     [sendOpts]             reference send function options
     */

  }, {
    key: 'requestVerificationSignature',
    value: function () {
      var _ref3 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee2(unsignedClaim, opts) {
        var _this8 = this;

        var id = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : (cov_1ytb5bt5lt.b[42][0]++, 'verSigReq');
        var sendOpts = arguments[3];
        return _regenerator2.default.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                cov_1ytb5bt5lt.f[30]++;
                cov_1ytb5bt5lt.s[111]++;
                _context2.next = 4;
                return this.signAndUploadProfile();

              case 4:
                cov_1ytb5bt5lt.s[112]++;

                if (!(typeof opts === 'string')) {
                  _context2.next = 13;
                  break;
                }

                cov_1ytb5bt5lt.b[43][0]++;
                cov_1ytb5bt5lt.s[113]++;

                console.warn('The subject argument is deprecated, use option object with {sub: sub, ...}');
                cov_1ytb5bt5lt.s[114]++;
                opts = { sub: opts };
                _context2.next = 22;
                break;

              case 13:
                cov_1ytb5bt5lt.b[43][1]++;
                cov_1ytb5bt5lt.s[115]++;

                if (!((cov_1ytb5bt5lt.b[45][0]++, !opts) || (cov_1ytb5bt5lt.b[45][1]++, !opts.sub))) {
                  _context2.next = 21;
                  break;
                }

                cov_1ytb5bt5lt.b[44][0]++;
                cov_1ytb5bt5lt.s[116]++;
                throw new Error('Missing required field sub in opts.  Received: ' + opts);

              case 21:
                cov_1ytb5bt5lt.b[44][1]++;

              case 22:
                cov_1ytb5bt5lt.s[117]++;


                this.credentials.createVerificationSignatureRequest(unsignedClaim, (0, _extends3.default)({}, opts, { aud: this.did, callbackUrl: this.genCallback(id), vc: this.vc })).then(function (jwt) {
                  cov_1ytb5bt5lt.f[31]++;
                  cov_1ytb5bt5lt.s[118]++;
                  return _this8.send(jwt, id, sendOpts);
                });

              case 24:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function requestVerificationSignature(_x5, _x6) {
        return _ref3.apply(this, arguments);
      }

      return requestVerificationSignature;
    }()

    /**
     * Creates and sends a request to a user to sign a piece of ERC712 Typed Data
     * 
     * @param     {Object}    typedData               an object containing unsigned typed, structured data that follows the ERC712 specification  
     * @param     {String}    [id='typedDataSigReq']  string to identify request, later used to get response
     * @param     {Object}    [sendOpts]              reference send function options
     */

  }, {
    key: 'requestTypedDataSignature',
    value: function requestTypedDataSignature(typedData) {
      var _this9 = this;

      var id = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : (cov_1ytb5bt5lt.b[46][0]++, 'typedDataSigReq');
      var sendOpts = arguments[2];
      cov_1ytb5bt5lt.f[32]++;

      var opts = (cov_1ytb5bt5lt.s[119]++, {
        callback: this.genCallback(id),
        net: this.network.id
      });
      cov_1ytb5bt5lt.s[120]++;
      if (this.address) {
          cov_1ytb5bt5lt.b[47][0]++;
          cov_1ytb5bt5lt.s[121]++;
          opts.from = this.address;
        } else {
        cov_1ytb5bt5lt.b[47][1]++;
      }cov_1ytb5bt5lt.s[122]++;
      this.credentials.createTypedDataSignatureRequest(typedData, opts).then(function (jwt) {
        cov_1ytb5bt5lt.f[33]++;
        cov_1ytb5bt5lt.s[123]++;
        return _this9.send(jwt, id, sendOpts);
      });
    }

    /**
     * Creates and sends a request to a user to sign an arbitrary data string
     * 
     * @param {String} data                   a string representing a piece of arbitrary data
     * @param {String} [id='personalSignReq'] 
     * @param {Object} [sendOpts]
     */

  }, {
    key: 'requestPersonalSign',
    value: function requestPersonalSign(data) {
      var _this10 = this;

      var id = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : (cov_1ytb5bt5lt.b[48][0]++, 'personalSignReq');
      var sendOpts = arguments[2];
      cov_1ytb5bt5lt.f[34]++;

      var opts = (cov_1ytb5bt5lt.s[124]++, {
        callback: this.genCallback(id),
        net: this.network.id
      });
      cov_1ytb5bt5lt.s[125]++;
      if (this.address) {
          cov_1ytb5bt5lt.b[49][0]++;
          cov_1ytb5bt5lt.s[126]++;
          opts.from = this.address;
        } else {
        cov_1ytb5bt5lt.b[49][1]++;
      }cov_1ytb5bt5lt.s[127]++;
      this.credentials.createPersonalSignRequest(data, opts).then(function (jwt) {
        cov_1ytb5bt5lt.f[35]++;
        cov_1ytb5bt5lt.s[128]++;
        return _this10.send(jwt, id, sendOpts);
      });
    }

    /**
     *  Creates a [Selective Disclosure Request JWT](https://github.com/uport-project/specs/blob/develop/messages/sharereq.md) and sends request message to uPort client.
     *
     *  @example
     *  const req = { requested: ['name', 'country'],
     *                callbackUrl: 'https://myserver.com',
     *                notifications: true }
     *  const reqID = 'disclosureReq'
     *  connect.requestDisclosure(req, reqID)
     *  connect.onResponse(reqID).then(jwt => {
     *      ...
     *  })
     *
     *  @param    {Object}     [reqObj={}]           request params object
     *  @param    {Array}      reqObj.requested      an array of attributes for which you are requesting credentials to be shared for
     *  @param    {Array}      reqObj.verified       an array of attributes for which you are requesting verified credentials to be shared for
     *  @param    {Boolean}    reqObj.notifications  boolean if you want to request the ability to send push notifications
     *  @param    {String}     reqObj.callbackUrl    the url which you want to receive the response of this request
     *  @param    {String}     reqObj.networkId      Override default network id of Ethereum chain of identity eg. 0x4 for rinkeby
     *  @param    {String}     reqObj.rpcUrl         Override default JSON RPC url for networkId. This is generally only required for use with private chains.
     *  @param    {String}     reqObj.accountType    Ethereum account type: "general", "keypair", or "none"
     *  @param    {Number}     reqObj.expiresIn      Seconds until expiry
     *  @param    {String}     [id='disclosureReq']  string to identify request, later used to get response
     *  @param    {Object}     [sendOpts]            reference send function options
     */

  }, {
    key: 'requestDisclosure',
    value: function () {
      var _ref4 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee3() {
        var reqObj = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (cov_1ytb5bt5lt.b[50][0]++, {});

        var _this11 = this;

        var id = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : (cov_1ytb5bt5lt.b[51][0]++, 'disclosureReq');
        var sendOpts = arguments[2];
        return _regenerator2.default.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                cov_1ytb5bt5lt.f[36]++;
                cov_1ytb5bt5lt.s[129]++;

                if (reqObj.vc) {
                  _context3.next = 9;
                  break;
                }

                cov_1ytb5bt5lt.b[52][0]++;
                cov_1ytb5bt5lt.s[130]++;
                _context3.next = 7;
                return this.signAndUploadProfile();

              case 7:
                _context3.next = 10;
                break;

              case 9:
                cov_1ytb5bt5lt.b[52][1]++;

              case 10:
                cov_1ytb5bt5lt.s[131]++;

                // Augment request object with verified claims, accountType, and a callback url
                reqObj = (0, _assign2.default)({
                  vc: this.vc,
                  accountType: (cov_1ytb5bt5lt.b[53][0]++, this.accountType) || (cov_1ytb5bt5lt.b[53][1]++, 'none'),
                  callbackUrl: this.genCallback(id)
                }, reqObj);

                cov_1ytb5bt5lt.s[132]++;
                if (reqObj.accountType != 'none') {
                  cov_1ytb5bt5lt.b[54][0]++;
                  cov_1ytb5bt5lt.s[133]++;

                  reqObj.networkId = this.network.id;
                  cov_1ytb5bt5lt.s[134]++;
                  reqObj.rpcUrl = this.network.rpcUrl;
                } else {
                  cov_1ytb5bt5lt.b[54][1]++;
                }

                // Create and send request
                cov_1ytb5bt5lt.s[135]++;
                this.credentials.createDisclosureRequest(reqObj, reqObj.expiresIn).then(function (jwt) {
                  cov_1ytb5bt5lt.f[37]++;
                  cov_1ytb5bt5lt.s[136]++;
                  return _this11.send(jwt, id, sendOpts);
                });

              case 16:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function requestDisclosure() {
        return _ref4.apply(this, arguments);
      }

      return requestDisclosure;
    }()

    /**
     *  Create and send a verification (credential) about connnected user. Verification is signed by
     *  temporary session keys created by Connect. If you want to create a verification with a different
     *  keypair/did use uPort credentials and send it with the Connect send function.
     *
     *  @example
     *  connect.sendVerification({
     *   exp: <future timestamp>,
     *   claim: { name: 'John Smith' }
     *  }, 'REQUEST_ID')
     *  connect.onResponse('REQUEST_ID').then(credential => {
     *   ...
     *  })
     *
     * @param    {Object}     [verification]        a unsigned verification object, by default the sub is the connected user
     * @param    {Object}     verification.claim    a claim about the subject, single key value or key mapping to object with multiple values (ie { address: {street: ..., zip: ..., country: ...}})
     * @param    {String}     verification.exp      time at which this verification expires and is no longer valid (seconds since epoch)
     * @param    {String}     [id='sendVerReq']     string to identify request, later used to get response
     * @param    {Object}     [sendOpts]            reference send function options
     */

  }, {
    key: 'sendVerification',
    value: function () {
      var _ref5 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee4() {
        var verification = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (cov_1ytb5bt5lt.b[55][0]++, {});

        var _this12 = this;

        var id = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : (cov_1ytb5bt5lt.b[56][0]++, 'sendVerReq');
        var sendOpts = arguments[2];
        var cb;
        return _regenerator2.default.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                cov_1ytb5bt5lt.f[38]++;
                cov_1ytb5bt5lt.s[137]++;

                if (verification.vc) {
                  _context4.next = 9;
                  break;
                }

                cov_1ytb5bt5lt.b[57][0]++;
                cov_1ytb5bt5lt.s[138]++;
                _context4.next = 7;
                return this.signAndUploadProfile();

              case 7:
                _context4.next = 10;
                break;

              case 9:
                cov_1ytb5bt5lt.b[57][1]++;

              case 10:
                // Callback and message form differ for this req, may be reconciled in the future
                cb = (cov_1ytb5bt5lt.s[139]++, this.genCallback(id));
                cov_1ytb5bt5lt.s[140]++;

                verification = (0, _extends3.default)({ sub: this.did, vc: this.vc }, verification);
                cov_1ytb5bt5lt.s[141]++;
                this.credentials.createVerification(verification).then(function (jwt) {
                  cov_1ytb5bt5lt.f[39]++;

                  var uri = (cov_1ytb5bt5lt.s[142]++, _uportTransports.message.util.paramsToQueryString(_uportTransports.message.util.messageToURI(jwt), { 'callback_url': cb }));
                  cov_1ytb5bt5lt.s[143]++;
                  _this12.send(uri, id, sendOpts);
                });

              case 15:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function sendVerification() {
        return _ref5.apply(this, arguments);
      }

      return sendVerification;
    }()

    /**
     * Update the internal state of the connect instance and ensure that it is consistent
     * with the state saved to localStorage.  You can pass in an object containing key-value pairs to update,
     * or a function that returns updated key-value pairs as a function of the current state.
     *
     * @param {Function|Object} Update -- An object, or function specifying updates to the current Connect state (as a function of the current state)
     */

  }, {
    key: 'setState',
    value: function setState(update) {
      cov_1ytb5bt5lt.f[40]++;
      cov_1ytb5bt5lt.s[144]++;

      switch (typeof update === 'undefined' ? 'undefined' : (0, _typeof3.default)(update)) {
        case 'object':
          cov_1ytb5bt5lt.b[58][0]++;
          cov_1ytb5bt5lt.s[145]++;

          this._state = (0, _extends3.default)({}, this._state, update);
          cov_1ytb5bt5lt.s[146]++;
          break;
        case 'function':
          cov_1ytb5bt5lt.b[58][1]++;
          cov_1ytb5bt5lt.s[147]++;

          this._state = update(this._state);
          cov_1ytb5bt5lt.s[148]++;
          break;
        case 'undefined':
          cov_1ytb5bt5lt.b[58][2]++;
          cov_1ytb5bt5lt.s[149]++;

          break;
        default:
          cov_1ytb5bt5lt.b[58][3]++;
          cov_1ytb5bt5lt.s[150]++;

          throw new Error('Cannot update state with ' + update);
      }
      // Normalize address to mnid

      var _ref6 = (cov_1ytb5bt5lt.s[151]++, this._state),
          mnid = _ref6.mnid;

      cov_1ytb5bt5lt.s[152]++;

      if ((0, _mnid.isMNID)(mnid)) {
        cov_1ytb5bt5lt.b[59][0]++;
        cov_1ytb5bt5lt.s[153]++;

        this._state.address = (0, _mnid.decode)(mnid).address;
      } else {
          cov_1ytb5bt5lt.b[59][1]++;
          cov_1ytb5bt5lt.s[154]++;
          if (mnid) {
            cov_1ytb5bt5lt.b[60][0]++;
            cov_1ytb5bt5lt.s[155]++;

            // Don't allow setting an invalid mnid
            throw new Error('Invalid MNID: ' + this._state.mnid);
          } else {
            cov_1ytb5bt5lt.b[60][1]++;
          }
        }cov_1ytb5bt5lt.s[156]++;
      if ((cov_1ytb5bt5lt.b[62][0]++, this.publicEncKey) && (cov_1ytb5bt5lt.b[62][1]++, this.pushToken)) {
        cov_1ytb5bt5lt.b[61][0]++;
        cov_1ytb5bt5lt.s[157]++;

        this.pushTransport = pushTransport(this.pushToken, this.publicEncKey);
      } else {
        cov_1ytb5bt5lt.b[61][1]++;
      }

      // Write to localStorage
      cov_1ytb5bt5lt.s[158]++;
      if (this.useStore) {
          cov_1ytb5bt5lt.b[63][0]++;
          cov_1ytb5bt5lt.s[159]++;
          this.store.set(this._state);
        } else {
        cov_1ytb5bt5lt.b[63][1]++;
      }
    }

    /**
     * Load state from local storage and set this instance's state accordingly.
     */

  }, {
    key: 'loadState',
    value: function loadState() {
      var _this13 = this;

      cov_1ytb5bt5lt.f[41]++;
      cov_1ytb5bt5lt.s[160]++;

      // replace state
      if (this.useStore) {
          cov_1ytb5bt5lt.b[64][0]++;
          cov_1ytb5bt5lt.s[161]++;
          this.setState(function (state) {
            cov_1ytb5bt5lt.f[42]++;
            cov_1ytb5bt5lt.s[162]++;
            return _this13.store.get();
          });
        } else {
        cov_1ytb5bt5lt.b[64][1]++;
      }
    }

    /**
     * Clear any user-specific state from the browser, (both the Connect instance and localStorage)
     * effectively logging them out. The keypair (app-instance identity) is preserved
     */

  }, {
    key: 'logout',
    value: function logout() {
      cov_1ytb5bt5lt.f[43]++;
      cov_1ytb5bt5lt.s[163]++;

      // Clear explicit state
      this.setState(function (state) {
        cov_1ytb5bt5lt.f[44]++;
        cov_1ytb5bt5lt.s[164]++;
        return { keypair: state.keypair };
      });
      // Clear all instance variables with references to current state
      cov_1ytb5bt5lt.s[165]++;
      this.pushTransport = null;
    }

    /**
     * Clear the entire state of the connect instance, including the keypair, from memory
     * and localStorage.  Rebuild this.credentials with a new app-instance identity
     */

  }, {
    key: 'reset',
    value: function reset() {
      cov_1ytb5bt5lt.f[45]++;
      cov_1ytb5bt5lt.s[166]++;

      this.logout();
      // Rebuild credentials
      cov_1ytb5bt5lt.s[167]++;
      this.keypair = _uportCredentials.Credentials.createIdentity();
      cov_1ytb5bt5lt.s[168]++;
      this.credentials = new _uportCredentials.Credentials((0, _extends3.default)({}, this.keypair, this.resolverConfigs));
    }

    /**
     * Accessor methods for Connect state.  The state consists of the key-value pairs below
     *  (did, doc, mnid, address, keypair, pushToken, and publicEncKey)
     * @private
     */

  }, {
    key: 'genCallback',


    /**
     *  @private
     */
    value: function genCallback(reqId) {
      cov_1ytb5bt5lt.f[64]++;
      cov_1ytb5bt5lt.s[191]++;

      return this.isOnMobile ? (cov_1ytb5bt5lt.b[67][0]++, windowCallback(reqId)) : (cov_1ytb5bt5lt.b[67][1]++, _uportTransports.transport.messageServer.genCallback());
    }

    /**
     * @private
     * Sign a profile object with this.credentials, and upload it to ipfs, prepending
     * the instance array of verified claims (this.vc) with the ipfs uri.  If a profile
     * object is not provided, create one on the fly 
     * @param {Object}  [profile]         the profile object to be signed and uploaded
     * @returns {Promise<String, Error>}  a promise resolving to the ipfs hash, or rejecting with an error
     */

  }, {
    key: 'signAndUploadProfile',
    value: function signAndUploadProfile(profile) {
      var _this14 = this;

      cov_1ytb5bt5lt.f[65]++;
      cov_1ytb5bt5lt.s[192]++;

      if ((cov_1ytb5bt5lt.b[69][0]++, !profile) && (cov_1ytb5bt5lt.b[69][1]++, this.vc.length > 0)) {
          cov_1ytb5bt5lt.b[68][0]++;
          cov_1ytb5bt5lt.s[193]++;
          return;
        } else {
        cov_1ytb5bt5lt.b[68][1]++;
      }cov_1ytb5bt5lt.s[194]++;
      profile = (cov_1ytb5bt5lt.b[70][0]++, profile) || (cov_1ytb5bt5lt.b[70][1]++, {
        name: this.appName,
        description: this.description,
        url: typeof window !== 'undefined' ? (cov_1ytb5bt5lt.b[71][0]++, window.location.protocol + '//' + window.location.host) : (cov_1ytb5bt5lt.b[71][1]++, undefined),
        profileImage: this.profileImage,
        bannerImage: this.bannerImage,
        brandColor: this.brandColor

        // Upload to ipfs
      });cov_1ytb5bt5lt.s[195]++;
      return this.credentials.createVerification({ sub: this.keypair.did, claim: profile }).then(function (jwt) {
        cov_1ytb5bt5lt.f[66]++;
        cov_1ytb5bt5lt.s[196]++;
        return (0, _util.ipfsAdd)(jwt);
      }).then(function (hash) {
        cov_1ytb5bt5lt.f[67]++;
        cov_1ytb5bt5lt.s[197]++;

        console.log('uploaded, ', _this14.vc);
        cov_1ytb5bt5lt.s[198]++;
        _this14.vc.unshift('/ipfs/' + hash);
        cov_1ytb5bt5lt.s[199]++;
        return hash;
      });
    }
  }, {
    key: 'state',
    get: function get() {
      cov_1ytb5bt5lt.f[46]++;
      cov_1ytb5bt5lt.s[169]++;
      return this._state;
    },


    /**
     * Setter methods with appropriate validation
     * @private
     */

    set: function set(state) {
      cov_1ytb5bt5lt.f[55]++;
      cov_1ytb5bt5lt.s[178]++;
      throw new Error('Use setState to set state object');
    }
  }, {
    key: 'did',
    get: function get() {
      cov_1ytb5bt5lt.f[47]++;
      cov_1ytb5bt5lt.s[170]++;
      return this._state.did;
    },
    set: function set(did) {
      cov_1ytb5bt5lt.f[56]++;
      cov_1ytb5bt5lt.s[179]++;
      this.setState({ did: did });
    }
  }, {
    key: 'doc',
    get: function get() {
      cov_1ytb5bt5lt.f[48]++;
      cov_1ytb5bt5lt.s[171]++;
      return (0, _extends3.default)({}, this._state.doc);
    },
    set: function set(doc) {
      cov_1ytb5bt5lt.f[57]++;
      cov_1ytb5bt5lt.s[180]++;
      this.setState({ doc: doc });
    }
  }, {
    key: 'mnid',
    get: function get() {
      cov_1ytb5bt5lt.f[49]++;
      cov_1ytb5bt5lt.s[172]++;
      return this._state.mnid;
    },
    set: function set(mnid) {
      cov_1ytb5bt5lt.f[58]++;
      cov_1ytb5bt5lt.s[181]++;
      this.setState({ mnid: mnid });
    }
  }, {
    key: 'address',
    get: function get() {
      cov_1ytb5bt5lt.f[50]++;
      cov_1ytb5bt5lt.s[173]++;
      return this._state.address;
    },


    // Address field alone is deprectated.  Allow setting an mnid, but not an unqualified address
    set: function set(address) {
      cov_1ytb5bt5lt.f[63]++;
      cov_1ytb5bt5lt.s[186]++;

      if ((0, _mnid.isMNID)(address)) {
        cov_1ytb5bt5lt.b[65][0]++;
        cov_1ytb5bt5lt.s[187]++;

        this.setState({ mnid: address });
      } else {
        cov_1ytb5bt5lt.b[65][1]++;
        cov_1ytb5bt5lt.s[188]++;

        if (address === this.address) {
            cov_1ytb5bt5lt.b[66][0]++;
            cov_1ytb5bt5lt.s[189]++;
            return;
          } else {
          cov_1ytb5bt5lt.b[66][1]++;
        }cov_1ytb5bt5lt.s[190]++;
        throw new Error('Setting an Ethereum address without a network id is not supported.  Use an MNID instead.');
      }
    }
  }, {
    key: 'keypair',
    get: function get() {
      cov_1ytb5bt5lt.f[51]++;
      cov_1ytb5bt5lt.s[174]++;
      return (0, _extends3.default)({}, this._state.keypair);
    },
    set: function set(keypair) {
      cov_1ytb5bt5lt.f[59]++;
      cov_1ytb5bt5lt.s[182]++;
      this.setState({ keypair: keypair });
    }
  }, {
    key: 'verified',
    get: function get() {
      cov_1ytb5bt5lt.f[52]++;
      cov_1ytb5bt5lt.s[175]++;
      return this._state.verified;
    },
    set: function set(verified) {
      cov_1ytb5bt5lt.f[60]++;
      cov_1ytb5bt5lt.s[183]++;
      this.setState({ verified: verified });
    }
  }, {
    key: 'pushToken',
    get: function get() {
      cov_1ytb5bt5lt.f[53]++;
      cov_1ytb5bt5lt.s[176]++;
      return this._state.pushToken;
    },
    set: function set(pushToken) {
      cov_1ytb5bt5lt.f[61]++;
      cov_1ytb5bt5lt.s[184]++;
      this.setState({ pushToken: pushToken });
    }
  }, {
    key: 'publicEncKey',
    get: function get() {
      cov_1ytb5bt5lt.f[54]++;
      cov_1ytb5bt5lt.s[177]++;
      return this._state.publicEncKey;
    },
    set: function set(publicEncKey) {
      cov_1ytb5bt5lt.f[62]++;
      cov_1ytb5bt5lt.s[185]++;
      this.setState({ publicEncKey: publicEncKey });
    }
  }]);
  return Connect;
}();

var LOCALSTOREKEY = (cov_1ytb5bt5lt.s[200]++, 'connectState');

var LocalStorageStore = function () {
  function LocalStorageStore() {
    var key = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (cov_1ytb5bt5lt.b[72][0]++, LOCALSTOREKEY);
    (0, _classCallCheck3.default)(this, LocalStorageStore);
    cov_1ytb5bt5lt.f[68]++;
    cov_1ytb5bt5lt.s[201]++;

    this.key = key;
  }

  (0, _createClass3.default)(LocalStorageStore, [{
    key: 'get',
    value: function get() {
      cov_1ytb5bt5lt.f[69]++;
      cov_1ytb5bt5lt.s[202]++;

      return JSON.parse((cov_1ytb5bt5lt.b[73][0]++, _store2.default.get(this.key)) || (cov_1ytb5bt5lt.b[73][1]++, '{}'));
    }
  }, {
    key: 'set',
    value: function set(stateObj) {
      cov_1ytb5bt5lt.f[70]++;
      cov_1ytb5bt5lt.s[203]++;

      _store2.default.set(this.key, (0, _stringify2.default)(stateObj));
    }
  }]);
  return LocalStorageStore;
}();

/**
 *  A transport created for uPort connect. Bundles transport functionality from uport-transports. This implements the
 *  default QR modal flow on desktop clients. If given a request which uses the messaging server Chasqui to relay
 *  responses, it will by default poll Chasqui and return response. If given a request which specifies another
 *  callback to receive the response, for example your own server, it will show the request in the default QR
 *  modal and then instantly return. You can then handle how to fetch the response specific to your implementation.
 *
 *  @param    {String}       appName                 App name displayed in QR pop over modal
 *  @return   {Function}                             Configured connectTransport function
 *  @param    {String}       request                 uPort client request message
 *  @param    {Object}       [config={}]             Optional config object
 *  @param    {String}       config.data             Additional data to be returned later with response
 *  @return   {Promise<Object, Error>}               Function to close the QR modal
 *  @private
 */


cov_1ytb5bt5lt.s[204]++;
var connectTransport = function connectTransport(appName) {
  cov_1ytb5bt5lt.f[71]++;
  cov_1ytb5bt5lt.s[205]++;
  return function (request, _ref7) {
    var data = _ref7.data,
        cancel = _ref7.cancel;
    cov_1ytb5bt5lt.f[72]++;
    cov_1ytb5bt5lt.s[206]++;

    if (_uportTransports.transport.messageServer.isMessageServerCallback(request)) {
      cov_1ytb5bt5lt.b[74][0]++;
      cov_1ytb5bt5lt.s[207]++;

      return _uportTransports.transport.qr.chasquiSend({ appName: appName })(request).then(function (res) {
        cov_1ytb5bt5lt.f[73]++;
        cov_1ytb5bt5lt.s[208]++;
        return { payload: res, data: data };
      });
    } else {
      cov_1ytb5bt5lt.b[74][1]++;
      cov_1ytb5bt5lt.s[209]++;

      _uportTransports.transport.qr.send(appName)(request, { cancel: cancel });
      // TODO return close QR func?
      cov_1ytb5bt5lt.s[210]++;
      return _promise2.default.resolve({ data: data });
    }
  };
};

/**
 * Wrap push transport from uport-transports, providing stored pushToken and publicEncKey from the
 * provided Connect instance
 * @param   {Connect} connect   The Connect instance holding the pushToken and publicEncKey
 * @returns {Function}          Configured pushTransport function
 * @private
 */
cov_1ytb5bt5lt.s[211]++;
var pushTransport = function pushTransport(pushToken, publicEncKey) {
  cov_1ytb5bt5lt.f[74]++;

  var send = (cov_1ytb5bt5lt.s[212]++, _uportTransports.transport.push.sendAndNotify(pushToken, publicEncKey));

  cov_1ytb5bt5lt.s[213]++;
  return function (request, _ref8) {
    var type = _ref8.type,
        redirectUrl = _ref8.redirectUrl,
        data = _ref8.data;
    cov_1ytb5bt5lt.f[75]++;
    cov_1ytb5bt5lt.s[214]++;

    if (_uportTransports.transport.messageServer.isMessageServerCallback(request)) {
      cov_1ytb5bt5lt.b[75][0]++;
      cov_1ytb5bt5lt.s[215]++;

      return _uportTransports.transport.messageServer.URIHandlerSend(send)(request, { type: type, redirectUrl: redirectUrl }).then(function (res) {
        cov_1ytb5bt5lt.f[76]++;
        cov_1ytb5bt5lt.s[216]++;

        _uportTransports.transport.ui.close();
        cov_1ytb5bt5lt.s[217]++;
        return { payload: res, data: data };
      });
    } else {
      cov_1ytb5bt5lt.b[75][1]++;
      cov_1ytb5bt5lt.s[218]++;

      // Return immediately for custom message server
      send(request, { type: type, redirectUrl: redirectUrl });
      cov_1ytb5bt5lt.s[219]++;
      return _promise2.default.resolve({ data: data });
    }
  };
};

/**
 *  Gets current window url and formats as request callback
 *
 *  @return   {String}   Returns window url formatted as callback
 *  @private
 */
cov_1ytb5bt5lt.s[220]++;
var windowCallback = function windowCallback(id) {
  cov_1ytb5bt5lt.f[77]++;

  var md = (cov_1ytb5bt5lt.s[221]++, new _mobileDetect2.default(navigator.userAgent));
  var chromeAndIOS = (cov_1ytb5bt5lt.s[222]++, (cov_1ytb5bt5lt.b[76][0]++, md.userAgent() === 'Chrome') && (cov_1ytb5bt5lt.b[76][1]++, md.os() === 'iOS'));
  var callback = (cov_1ytb5bt5lt.s[223]++, chromeAndIOS ? (cov_1ytb5bt5lt.b[77][0]++, 'googlechrome:' + window.location.href.substring(window.location.protocol.length)) : (cov_1ytb5bt5lt.b[77][1]++, window.location.href));
  cov_1ytb5bt5lt.s[224]++;
  return _uportTransports.message.util.paramsToUrlFragment(callback, { id: id });
};

exports.default = Connect;


//////////////////
// WEBPACK FOOTER
// ./~/uport-connect/lib/Connect.js
// module id = 901
// module chunks = 0